// tslint:disable
import React from 'react';

interface SeparabilityProps {
  SeparabilityDataNone?: boolean;
  SeparabilityDataExists?: boolean;
  SeparabilityDataOther?: boolean;
  SmallSeparator?: boolean;
  MediumSeparator?: boolean;
  LargeSeparator?: boolean;
  CheckedColor?: any;
  isChecked?: boolean;
  CheckedOnClick?: (event: React.MouseEvent<SVGElement>) => void;
  SeparatorSize?: number;
}

const Separation1 = () => (
  <svg
    width="100"
    height="88"
    viewBox="0 0 100 88"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="fluid-border">
        <path
          d="M20,0 L77,0 L76,75 L74,84 L50.5,85 L29,85 C27.8954926,84.6384345 27.2288259,84.3051012 27,84 C26.7711741,83.6948988 26.4378408,82.6948988 26,81 L23,41 L25,41 Z"
          stroke="#979797"
          x="0"
          y="0"
        />
      </clipPath>
    </defs>
    <g fillRule="evenodd" fill="none">
      <g className="fluidWrapper" clipPath="url(#fluid-border)">
        <path
          className="blueFluid"
          d="M0 22.99c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V84H0V22.99zm50 0c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V84H50V22.99z"
          fill="#A7CFFF"
        />
      </g>
    </g>
    <path
      d="M30.275 87.154h39.648c3.965 0 7.03-3.244 7.21-7.21l3.603-73.89c0-3.063-2.523-5.406-5.406-5.406H24.868c-3.064 0-5.406 2.342-5.406 5.407l3.604 73.89c.18 3.965 3.244 7.21 7.21 7.21zm43.252-7.21c0 1.983-1.622 3.605-3.604 3.605H30.275c-1.983 0-3.605-1.624-3.605-3.606l-3.604-73.89c0-1.08.72-1.8 1.802-1.8H75.33c1.08 0 1.802.72 1.802 1.8l-3.605 73.89zM33.88 45.704c0 1.08.72 1.8 1.8 1.8h18.023c1.082 0 1.802-.72 1.802-1.8s-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.722-1.8 1.803zm0-28.835c0 1.08.72 1.8 1.8 1.8h10.815c1.08 0 1.802-.72 1.802-1.8s-.72-1.803-1.802-1.803H35.68c-1.08 0-1.8.72-1.8 1.802zm0 43.252c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.8-1.802-1.8H35.68c-1.08 0-1.8.72-1.8 1.8zm0 14.418c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.8-1.802-1.8H35.68c-1.08 0-1.8.72-1.8 1.8zm0-43.252c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802s-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802z"
      fill="#7F7F7F"
    />

    <circle fill="#695646" cx="67.714" cy="80.143" r="1.804" />
    <circle fill="#695646" cx="53.703" cy="80.736" r="1.802" />
    <circle fill="#8A796B" cx="60.319" cy="75.33" r="1.802" />
    <circle fill="#695646" cx="67.22" cy="74.418" r="1" />
    <circle fill="#8A796B" cx="52.802" cy="72.022" r="1.903" />
  </svg>
);

const Separation2 = () => (
  <svg
    width="100"
    height="88"
    viewBox="0 0 100 88"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="fluid-border">
        <path
          d="M20,0 L77,0 L76,75 L74,84 L50.5,85 L29,85 C27.8954926,84.6384345 27.2288259,84.3051012 27,84 C26.7711741,83.6948988 26.4378408,82.6948988 26,81 L23,41 L25,41 Z"
          stroke="#979797"
          x="0"
          y="0"
        />
      </clipPath>
    </defs>
    <g fillRule="nonzero" fill="none">
      <g className="fluidWrapper" clipPath="url(#fluid-border)">
        <path
          className="yellowFluid"
          d="M0 24.99c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H0V24.99zm50 0c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H50V24.99z"
          fill="#FAF998"
        />
        <g className="goingDown">
          <path
            className="waving"
            d="M0 34.59c6 0 7-9.59 11-9.59s6 4.802 11 4.802S31 25 36 25s9 9.59 14 9.59v49.64H0V34.59zm50 0c6 0 7-9.59 11-9.59s6 4.802 11 4.802S81 25 86 25s9 9.59 14 9.59v49.64H50V34.59z"
            fill="#A7CFFF"
          />
        </g>
      </g>
    </g>
    <path
      d="M30.275 87.154h39.648c3.965 0 7.03-3.244 7.21-7.21l3.603-73.89c0-3.063-2.523-5.406-5.406-5.406H24.868c-3.064 0-5.406 2.343-5.406 5.407l3.604 73.89c.18 3.965 3.244 7.21 7.21 7.21zm43.252-7.21c0 1.983-1.622 3.605-3.604 3.605H30.275c-1.983 0-3.605-1.623-3.605-3.605l-3.604-73.89c0-1.08.72-1.802 1.802-1.802H75.33c1.08 0 1.802.72 1.802 1.802l-3.605 73.89zM33.88 45.705c0 1.08.72 1.8 1.8 1.8h18.023c1.082 0 1.802-.72 1.802-1.8 0-1.082-.72-1.803-1.802-1.803H35.68c-1.08 0-1.8.722-1.8 1.803zm0-28.836c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802zm0 43.253c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.8-1.802-1.8H35.68c-1.08 0-1.8.72-1.8 1.8zm0 14.418c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802zm0-43.252c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802s-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802z"
      fill="#7F7F7F"
    />
  </svg>
);

const Separation3 = () => (
  <svg
    width="100"
    height="88"
    viewBox="0 0 100 88"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="fluid-border">
        <path
          d="M20,0 L77,0 L76,75 L74,84 L50.5,85 L29,85 C27.8954926,84.6384345 27.2288259,84.3051012 27,84 C26.7711741,83.6948988 26.4378408,82.6948988 26,81 L23,41 L25,41 Z"
          stroke="#979797"
          x="0"
          y="0"
        />
      </clipPath>
    </defs>

    <g fillRule="nonzero" fill="none">
      <g className="fluidWrapper" clipPath="url(#fluid-border)">
        <path
          className="yellowFluid"
          d="M0 24.99c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H0V24.99zm50 0c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H50V24.99z"
          fill="#F5F39A"
        />

        <path
          className="blueFluid"
          d="M0 54.99c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H0V54.99zm50 0c6 0 7-5.99 11-5.99s6 3 11 3 9-3 14-3 9 5.99 14 5.99V86H50V54.99z"
          fill="#A7CFFF"
        />
      </g>
    </g>
    <path
      d="M30.275 87.154h39.648c3.965 0 7.03-3.244 7.21-7.21l3.603-73.89c0-3.063-2.523-5.406-5.406-5.406H24.868c-3.064 0-5.406 2.343-5.406 5.407l3.604 73.89c.18 3.965 3.244 7.21 7.21 7.21zm43.252-7.21c0 1.983-1.622 3.605-3.604 3.605H30.275c-1.983 0-3.605-1.623-3.605-3.605l-3.604-73.89c0-1.08.72-1.802 1.802-1.802H75.33c1.08 0 1.802.72 1.802 1.802l-3.605 73.89zM33.88 45.705c0 1.08.72 1.8 1.8 1.8h18.023c1.082 0 1.802-.72 1.802-1.8 0-1.082-.72-1.803-1.802-1.803H35.68c-1.08 0-1.8.722-1.8 1.803zm0-28.836c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802zm0 43.253c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.8-1.802-1.8H35.68c-1.08 0-1.8.72-1.8 1.8zm0 14.418c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802zm0-43.252c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802s-.72-1.802-1.802-1.802H35.68c-1.08 0-1.8.72-1.8 1.802z"
      fill="#7F7F7F"
    />
    <circle fill="#695646" cx="67.714" cy="80.143" r="1.804" />
    <circle fill="#695646" cx="53.703" cy="80.736" r="1.802" />
    <circle fill="#8A796B" cx="60.319" cy="75.33" r="1.802" />
    <circle fill="#695646" cx="67.22" cy="74.418" r="1" />
    <circle fill="#8A796B" cx="52.802" cy="72.022" r="1.903" />
  </svg>
);

const Separation4 = () => (
  <svg
    width="62"
    height="88"
    viewBox="0 0 62 88"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.275 87.154h39.648c3.965 0 7.03-3.244 7.21-7.21l3.603-73.89c0-3.063-2.523-5.406-5.406-5.406H5.868C2.804.648.462 2.99.462 6.055l3.604 73.89c.18 3.965 3.244 7.21 7.21 7.21zm43.252-7.21c0 1.983-1.622 3.605-3.604 3.605H11.275c-1.983 0-3.605-1.623-3.605-3.605L4.066 6.055c0-1.08.72-1.802 1.802-1.802H56.33c1.08 0 1.802.72 1.802 1.802l-3.605 73.89zM14.88 45.705c0 1.08.72 1.8 1.8 1.8h18.023c1.082 0 1.802-.72 1.802-1.8 0-1.082-.72-1.803-1.802-1.803H16.68c-1.08 0-1.8.722-1.8 1.803zm0-28.836c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H16.68c-1.08 0-1.8.72-1.8 1.802zm0 43.253c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.8-1.802-1.8H16.68c-1.08 0-1.8.72-1.8 1.8zm0 14.418c0 1.082.72 1.803 1.8 1.803h10.815c1.08 0 1.802-.72 1.802-1.802 0-1.08-.72-1.802-1.802-1.802H16.68c-1.08 0-1.8.72-1.8 1.802zm0-43.252c0 1.08.72 1.802 1.8 1.802h10.815c1.08 0 1.802-.72 1.802-1.802s-.72-1.802-1.802-1.802H16.68c-1.08 0-1.8.72-1.8 1.802z"
      fillRule="nonzero"
      fill="#7F7F7F"
    />
  </svg>
);

const SeparabilityDataNone = ({ SeparabilityDataNone }: SeparabilityProps) => (
  <svg
    width="47"
    height="57"
    viewBox="0 0 47 57"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill={SeparabilityDataNone ? 'var(--alPurple)' : '#7F7F7F'}
      fillRule="evenodd"
    >
      <path
        d="M10.08 12.594h9.36c.965 0 .965-1.497 0-1.497h-9.36c-.967 0-.967 1.497 0 1.497zM28.794 12.594h9.36c.967 0 .967-1.497 0-1.497h-9.36c-.966 0-.966 1.497 0 1.497zM35.235 15.94c.966 0 .966-1.5 0-1.5H29.17c-.967 0-.967 1.5 0 1.5h6.065z"
        fillRule="nonzero"
      />
      <path
        d="M35.96 2.685V.352H12.166v2.333H.47v53.917h46.015V2.685H35.96zm6.93 50.323H4.062V6.278h8.104v1.66H35.96v-1.66h6.93v46.73z"
        fillRule="nonzero"
      />
      <path d="M22.353 44.67v-3.032h2.975v3.032h-2.975zm1.71-21.56c.967 0 1.816.118 2.548.355.732.238 1.37.606 1.916 1.105.52.474.91 1.054 1.17 1.74.262.687.392 1.466.392 2.34 0 .65-.087 1.26-.26 1.834-.174.574-.422 1.123-.744 1.647-.347.5-.75 1.018-1.21 1.554-.458.537-.96 1.08-1.505 1.628-.274.275-.49.53-.652.768-.16.237-.266.455-.316.655-.05.2-.087.468-.11.805-.026.337-.04.717-.04 1.14H22.39c0-.697.03-1.29.093-1.777.062-.486.155-.867.28-1.14.098-.276.302-.594.612-.956s.713-.767 1.21-1.216c.47-.573.88-1.08 1.226-1.515.348-.437.62-.805.82-1.105.198-.324.346-.667.446-1.03.1-.36.148-.766.148-1.215 0-.5-.068-.95-.204-1.348-.137-.4-.34-.736-.614-1.01-.273-.275-.6-.487-.985-.637-.384-.15-.836-.225-1.357-.225-.446 0-.855.063-1.227.188-.372.124-.707.312-1.004.56-.322.226-.558.625-.707 1.2-.148.573-.223 1.097-.223 1.57H18.15l-.037-.11c-.025-.775.1-1.586.372-2.434.273-.85.694-1.51 1.264-1.985.57-.474 1.214-.824 1.933-1.048.72-.225 1.513-.337 2.38-.337z" />
    </g>
  </svg>
);

const SeparabilityDataExists = ({
  SeparabilityDataExists
}: SeparabilityProps) => (
  <svg
    width="47"
    height="57"
    viewBox="0 0 47 57"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fillRule="nonzero"
      fill={SeparabilityDataExists ? 'var(--alPurple)' : '#7F7F7F'}
    >
      <path d="M10.08 12.594h9.36c.965 0 .965-1.497 0-1.497h-9.36c-.967 0-.967 1.497 0 1.497zM22.753 40.743H8.133c-.966 0-.966 1.497 0 1.497h14.62c.965 0 .965-1.497 0-1.497zM28.866 41.104h-1.102c-1.738 0-1.738 2.696 0 2.696h1.102c1.74 0 1.74-2.696 0-2.696z" />
      <path d="M33.082 41.104h-1.1c-1.737 0-1.737 2.696 0 2.696h1.1c1.738 0 1.738-2.696 0-2.696z" />
      <path d="M37.476 41.104h-1.102c-1.738 0-1.738 2.696 0 2.696h1.102c1.738 0 1.738-2.696 0-2.696zM28.778 44.673h-1.1c-1.738 0-1.738 2.695 0 2.695h1.1c1.738 0 1.738-2.695 0-2.695z" />
      <path d="M32.994 44.673h-1.1c-1.738 0-1.738 2.695 0 2.695h1.1c1.738 0 1.738-2.695 0-2.695z" />
      <path d="M37.387 44.673h-1.102c-1.735 0-1.735 2.695 0 2.695h1.102c1.738 0 1.738-2.695 0-2.695zM22.753 43.487H8.133c-.966 0-.966 1.497 0 1.497h14.62c.965 0 .965-1.497 0-1.497zM28.794 12.594h9.36c.967 0 .967-1.497 0-1.497h-9.36c-.966 0-.966 1.497 0 1.497zM35.235 15.94c.966 0 .966-1.5 0-1.5H29.17c-.967 0-.967 1.5 0 1.5h6.065zM28.46 32.23c.197.632 1.083.83 1.416.193l1.29-2.48c.284.786.57 1.574.855 2.366.123.336.38.588.747.588h3.68c1 0 1-1.607 0-1.607h-2.695c-.274 0-.435.04-.53.087.007-.142-.028-.388-.174-.79l-1.01-2.793c-.222-.608-1.073-.852-1.42-.19l-1.234 2.374c-.676-2.18-1.355-4.364-2.033-6.544-.247-.795-1.222-.73-1.494 0-.723 1.958-1.446 7.508-2.168 9.463-.743-3.512-1.486-10.615-2.228-14.127-.166-.786-1.305-.748-1.495 0-.914 3.632-1.825 7.263-2.738 10.897l-1.544-3.285c-.324-.69-1.198-.39-1.417.19l-1.56 4.162c-.102.274-.178.44-.234.557H10.19c-1 0-1 1.608 0 1.608h2.833c.372 0 .62-.252.747-.59.44-1.175.882-2.348 1.323-3.524.56 1.198 1.124 2.395 1.687 3.59.3.64 1.256.45 1.417-.19l2.452-9.754c.696 3.292 1.392 10.178 2.088 13.472.18.845 1.244.68 1.495 0 .77-2.084 1.54-7.76 2.306-9.843.64 2.057 1.278 4.112 1.92 6.17z" />
      <path d="M35.96 2.685V.352H12.166v2.333H.47v53.917h46.015V2.685H35.96zm6.93 50.323H4.062V6.278h8.104v1.66H35.96v-1.66h6.93v46.73z" />
      <path d="M22.753 46.106H8.133c-.966 0-.966 1.498 0 1.498h14.62c.965 0 .965-1.498 0-1.498z" />
    </g>
  </svg>
);

const SeparabilityDataOther = ({
  SeparabilityDataOther
}: SeparabilityProps) => (
  <svg
    width="45"
    height="47"
    viewBox="0 0 45 47"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.508 20.144H23.1c-.2 0-.304.03-.37.066.006-.1-.02-.272-.122-.556l-.708-1.946c-.154-.425-.75-.596-.992-.133-.29.552-.578 1.103-.865 1.656-.475-1.52-.95-3.04-1.427-4.56-.173-.554-.858-.51-1.047 0l-1.52 4.092-1.562-7.343c-.117-.55-.916-.522-1.048 0l-1.92 7.594-1.08-2.29c-.228-.48-.84-.272-.993.132l-1.095 2.9c-.07.19-.124.307-.164.387h-1.6c-.7 0-.7 1.12 0 1.12h1.987c.26 0 .435-.175.524-.412l.925-2.454 1.183 2.502c.21.444.88.312.994-.134l1.718-6.8 1.463 6.886c.126.59.87.475 1.047 0 .54-1.45 1.078-2.902 1.618-4.356.448 1.436.896 2.87 1.345 4.303.138.442.76.58.992.133.3-.577.602-1.153.904-1.728l.6 1.648c.084.237.264.412.522.412h5.098c.697.002.697-1.118-.002-1.118zm6.02-2.893C33.53 7.927 26.166.34 17.116.34 8.063.34.697 7.927.697 17.25c0 9.326 7.365 16.912 16.417 16.912 9.05 0 16.415-7.586 16.415-16.91zM17.116 29.917c-6.78 0-12.295-5.682-12.295-12.666S10.335 4.586 17.115 4.586 29.41 10.266 29.41 17.25c0 6.985-5.517 12.666-12.295 12.666zm11.057 3.198l3.63-3.738 12.61 12.99-3.63 3.74-12.61-12.992z"
      fillRule="nonzero"
      fill={SeparabilityDataOther ? 'var(--alPurple)' : '#7F7F7F'}
    />
  </svg>
);

const EmailIcon = () => (
  <svg
    width="25px"
    height="20px"
    viewBox="0 0 25 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="new-footer"
        transform="translate(-1338.000000, -1763.000000)"
        fill="#AA998D"
      >
        <g id="Group-3" transform="translate(957.000000, 1757.000000)">
          <path
            d="M405.367784,12.9374868 L405.367784,23.5714281 C405.367784,24.7500009 404.403497,25.7142878 403.224924,25.7142878 L383.510615,25.7142878 C382.332042,25.7142878 381.367755,24.7500009 381.367755,23.5714281 L381.367755,12.9374868 C381.769541,13.3794516 382.224899,13.7678449 382.720435,14.1026668 C384.943652,15.6160614 387.193655,17.1294561 389.376693,18.723208 C390.501695,19.5535661 391.894553,20.5714245 393.354377,20.5714245 L393.381162,20.5714245 C394.840985,20.5714245 396.233844,19.5535661 397.358846,18.723208 C399.541884,17.142849 401.791887,15.6160614 404.028496,14.1026668 C404.51064,13.7678449 404.965998,13.3794516 405.367784,12.9374868 Z M405.367784,8.99998212 C405.367784,10.4999839 404.256175,11.8526641 403.077602,12.6696294 C400.988314,14.1160596 398.885633,15.5624899 396.809738,17.0223131 C395.939201,17.6249924 394.465985,18.8571367 393.381162,18.8571367 L393.354377,18.8571367 C392.269554,18.8571367 390.796338,17.6249924 389.925801,17.0223131 C387.849906,15.5624899 385.747225,14.1160596 383.671329,12.6696294 C382.720435,12.0267714 381.367755,10.5133768 381.367755,9.29462533 C381.367755,7.98212376 382.077577,6.85712242 383.510615,6.85712242 L403.224924,6.85712242 C404.390104,6.85712242 405.367784,7.82140929 405.367784,8.99998212 Z"
            id="envelope---FontAwesome"
          />
        </g>
      </g>
    </g>
  </svg>
);

const GlobeIcon = () => (
  <svg
    width="16px"
    height="16px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 496 512"
  >
    <path
      fill="currentColor"
      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"
    ></path>
  </svg>
);

const ChatIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.962 13.192l-.04-.038v-.077C.31 12.18 0 11.192 0 10.115c0-1.64.628-3 1.885-4.077-.103.565-.154 1-.154 1.308 0 1.77.655 3.29 1.962 4.558 1.308 1.27 2.885 1.904 4.73 1.904.59 0 1.155-.077 1.693-.23-1.153 1.358-2.628 2.037-4.423 2.037-.692 0-1.436-.153-2.23-.46h-.04c-.1-.052-.204-.078-.307-.078-.077 0-.192.026-.346.077L.614 16l.462-2.423c0-.128-.04-.256-.115-.385zM9.308 0c1.846 0 3.423.635 4.73 1.904C15.346 3.174 16 4.692 16 6.462c0 1.205-.36 2.36-1.077 3.46l-.038.04c-.026.025-.04.05-.04.076-.076.154-.114.308-.114.462l.655 2.846-2.654-1c-.153-.05-.28-.077-.384-.077-.077 0-.192.025-.346.076l-.077.04c-.205.076-.513.165-.923.268-.538.154-1.103.23-1.692.23-1.846 0-3.417-.628-4.712-1.884C3.3 9.744 2.654 8.23 2.654 6.462c0-.462.038-.91.115-1.347.307-1.46 1.076-2.68 2.307-3.653C6.307.487 7.717 0 9.307 0z"
      fill="#23337E"
      fillRule="evenodd"
    />
  </svg>
);

const ArrowRightIcon = () => (
  <svg viewBox="0 0 22 40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.362 0c-.187 0-.36.033-.52.098C.682.163.534.26.402.39.133.653 0 .97 0 1.35c0 .377.134.696.4.957l18.274 17.83L.64 37.732c-.266.26-.4.574-.4.94 0 .364.134.676.4.937.268.26.596.39.983.39s.715-.13.982-.39L21.6 21.074c.266-.26.4-.573.4-.938s-.134-.678-.4-.94L2.323.392C2.19.26 2.037.164 1.864.1 1.69.033 1.523 0 1.36 0z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);
const ArrowLeftIcon = () => (
  <svg viewBox="0 0 22 40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.638 0c.187 0 .36.033.52.098.16.065.308.163.44.293.268.262.402.58.402.96 0 .377-.134.696-.4.957L3.325 20.137 21.36 37.732c.266.26.4.574.4.94 0 .364-.134.676-.4.937-.268.26-.596.39-.983.39s-.715-.13-.982-.39L.4 21.074c-.266-.26-.4-.573-.4-.938s.134-.678.4-.94L19.677.392c.133-.13.287-.227.46-.292.174-.065.34-.098.502-.098z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    id="closeIcon"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 .25c2.76 0 5.358.52 7.793 1.563 2.435 1.04 4.557 2.467 6.367 4.277 1.81 1.81 3.236 3.932 4.278 6.367C39.477 14.892 40 17.49 40 20.25s-.52 5.358-1.563 7.793c-1.04 2.435-2.467 4.557-4.277 6.367-1.81 1.81-3.932 3.236-6.367 4.278-2.435 1.04-5.033 1.562-7.793 1.562s-5.358-.52-7.793-1.563C9.772 37.648 7.65 36.22 5.84 34.41c-1.81-1.81-3.236-3.932-4.277-6.367C.52 25.608 0 23.01 0 20.25s.52-5.358 1.563-7.793C2.603 10.022 4.03 7.9 5.84 6.09c1.81-1.81 3.932-3.236 6.367-4.277C14.642.77 17.24.25 20 .25zm0 37.54c2.422 0 4.694-.463 6.816-1.388 2.123-.924 3.972-2.18 5.547-3.77 1.576-1.588 2.826-3.443 3.75-5.566.925-2.122 1.387-4.394 1.387-6.816 0-2.422-.462-4.694-1.387-6.816-.924-2.123-2.174-3.972-3.75-5.547-1.575-1.576-3.424-2.826-5.547-3.75C24.694 3.212 22.422 2.75 20 2.75c-2.422 0-4.694.462-6.816 1.387-2.123.924-3.972 2.174-5.547 3.75-1.576 1.575-2.826 3.424-3.75 5.547C2.962 15.556 2.5 17.828 2.5 20.25c0 2.422.462 4.694 1.387 6.816.924 2.123 2.174 3.978 3.75 5.567 1.575 1.588 3.424 2.845 5.547 3.77 2.122.924 4.394 1.386 6.816 1.386zm7.07-24.61c.235.234.352.527.352.88 0 .35-.117.643-.352.877l-5.312 5.313 5.312 5.313c.235.234.352.527.352.878 0 .353-.117.646-.352.88-.234.235-.527.352-.88.352-.35 0-.643-.117-.878-.352L20 22.008l-5.313 5.312c-.234.235-.527.352-.878.352-.353 0-.646-.117-.88-.352-.235-.234-.352-.527-.352-.88 0-.35.117-.643.352-.878l5.312-5.312-5.312-5.313c-.235-.234-.352-.527-.352-.878 0-.353.117-.646.352-.88.234-.235.527-.352.88-.352.35 0 .643.117.877.352L20 18.492l5.313-5.312c.234-.235.527-.352.878-.352.353 0 .646.117.88.352z"
      fill="#23337E"
      fillRule="evenodd"
    />
  </svg>
);

const CogWheelsIcon = () => (
  <svg
    width="92"
    height="78"
    viewBox="0 0 92 78"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#7F7F7F" fillRule="evenodd">
      <path d="M47.15 45.505c-.537 0-1.02-.374-1.128-.922-.43-2.15-1.25-4.16-2.432-5.96-.345-.528-.197-1.243.335-1.59.53-.345 1.242-.197 1.59.334 1.345 2.047 2.27 4.323 2.764 6.767.124.62-.28 1.227-.905 1.348-.075.016-.15.023-.226.023m-2.564 14.038c-.217 0-.437-.06-.63-.183-.53-.35-.68-1.063-.33-1.594 1.183-1.8 2-3.815 2.43-5.986.12-.62.748-1.004 1.35-.906.623.125 1.027.725.906 1.348-.486 2.464-1.416 4.753-2.763 6.806-.222.335-.59.515-.964.515M28.716 38.02c-5.638 0-10.225 4.576-10.225 10.204 0 5.612 4.588 10.18 10.226 10.18 5.622 0 10.192-4.568 10.192-10.18 0-5.628-4.57-10.204-10.192-10.204m0 22.678c-6.907 0-12.525-5.596-12.525-12.474 0-6.89 5.62-12.5 12.526-12.5 6.887 0 12.492 5.61 12.492 12.5 0 6.878-5.605 12.474-12.492 12.474m4.008 7.045c-.532 0-1.012-.37-1.123-.91-.13-.62.27-1.228.89-1.36 2.186-.455 4.236-1.32 6.096-2.58.526-.355 1.24-.217 1.597.308.355.525.22 1.237-.306 1.595-2.11 1.423-4.435 2.407-6.916 2.925-.078.017-.157.023-.236.023M11.39 70.177c-.838 0-1.67-.315-2.303-.945l-1.22-1.207c-1.185-1.174-1.297-3.047-.255-4.352l4.015-5.045c-1.068-1.715-1.857-3.61-2.353-5.645l-6.364-.71C1.25 52.084 0 50.686 0 49.02V47.34c0-1.666 1.25-3.063 2.907-3.25l6.367-.712c.49-1.984 1.288-3.867 2.382-5.61l-4.04-5.053c-1.043-1.3-.94-3.17.242-4.35l1.222-1.22c1.177-1.18 3.053-1.282 4.36-.24l5.136 4.108c1.673-1.003 3.52-1.74 5.51-2.2l.746-6.606c.187-1.657 1.584-2.906 3.253-2.906h1.69c1.668 0 3.068 1.25 3.252 2.906l.752 6.714c2.086.518 4.11 1.414 6.02 2.673.528.352.675 1.064.324 1.592-.348.528-1.058.676-1.594.325-1.912-1.26-3.94-2.11-6.03-2.52-.49-.098-.863-.5-.916-1l-.84-7.527c-.057-.492-.474-.866-.97-.866h-1.69c-.495 0-.912.374-.968.866l-.838 7.43c-.056.5-.434.907-.93 1-2.297.436-4.386 1.272-6.213 2.482-.41.28-.966.256-1.354-.06L12 28.696c-.386-.308-.942-.28-1.293.072l-1.222 1.22c-.352.35-.385.906-.073 1.293l4.564 5.704c.316.393.335.95.046 1.367-1.32 1.92-2.22 4.04-2.674 6.3-.1.49-.503.862-1.003.917l-7.18.804c-.492.057-.863.47-.863.968v1.683c0 .5.37.913.864.97l7.18.802c.5.056.903.427 1.002.92.47 2.334 1.36 4.466 2.645 6.33.285.416.266.97-.046 1.364l-4.535 5.697c-.312.387-.276.945.076 1.296l1.216 1.202c.35.348.906.38 1.29.07l5.72-4.563c.39-.31.934-.336 1.348-.064 1.906 1.247 4.022 2.093 6.286 2.52.624.118 1.035.718.917 1.338-.12.626-.723 1.03-1.344.918-2.283-.43-4.435-1.24-6.406-2.414l-5.083 4.057c-.597.476-1.32.712-2.04.712" />
      <path
        d="M39.265 62.688h-.033c-.638 0-1.155.517-1.155 1.155s.517 1.155 1.155 1.155h.033c.638 0 1.155-.517 1.155-1.155s-.517-1.155-1.155-1.155z"
        fillRule="nonzero"
      />
      <path d="M29.775 77.09h-1.692c-1.666 0-3.066-1.245-3.253-2.895l-.838-7.374c-.072-.625.38-1.196 1.012-1.268.64-.095 1.203.384 1.275 1.014l.834 7.37c.06.492.473.862.97.862h1.69c.497 0 .915-.37.97-.866l.838-7.462c.073-.63.66-1.102 1.272-1.013.63.072 1.084.636 1.015 1.27l-.842 7.46c-.184 1.658-1.584 2.904-3.253 2.904" />
      <path
        d="M45.457 38.717l4.8-6.006c1.04-1.296.94-3.17-.235-4.347l-1.208-1.215c-1.177-1.185-3.054-1.296-4.363-.258l-6 4.755c-.5.396-.585 1.123-.19 1.623.397.5 1.123.584 1.623.188l6.003-4.756c.388-.307.94-.274 1.29.076l1.21 1.217c.344.346.373.894.068 1.274l-4.802 6.007c-.398.5-.317 1.225.18 1.624.5.398 1.227.317 1.625-.18zM47.02 45.506l7.71.872c.49.054.856.464.856.955v1.693c0 .49-.367.902-.857.958l-7.677.87c-.634.07-1.09.643-1.017 1.277.07.634.643 1.09 1.277 1.018l7.676-.87c1.656-.186 2.906-1.585 2.906-3.252v-1.693c0-1.668-1.252-3.068-2.91-3.25l-7.706-.872c-.634-.07-1.206.385-1.277 1.018-.072.634.384 1.206 1.017 1.278zM43.683 59.117l4.77 5.996c.306.385.274.936-.074 1.286l-1.195 1.186c-.35.348-.906.38-1.29.073l-5.91-4.72c-.5-.398-1.226-.317-1.624.182-.397.498-.316 1.225.183 1.623l5.91 4.72c1.305 1.038 3.18.933 4.362-.24l1.196-1.192c1.18-1.182 1.287-3.05.253-4.357L45.49 57.68c-.397-.5-1.124-.583-1.623-.186-.5.397-.58 1.124-.184 1.623z"
        fillRule="nonzero"
      />
      <path d="M83.786 18.966c-.54 0-1.02-.378-1.127-.925-.287-1.426-.83-2.758-1.615-3.955-.345-.53-.2-1.243.336-1.59.526-.342 1.243-.2 1.59.334.947 1.442 1.6 3.046 1.943 4.764.125.62-.28 1.227-.904 1.35-.076.015-.152.022-.224.022M82.03 28.59c-.22 0-.436-.063-.63-.19-.532-.346-.68-1.057-.332-1.59.786-1.2 1.328-2.537 1.61-3.977.122-.624.736-1.034 1.35-.906.625.122 1.033.73.91 1.348-.344 1.732-.995 3.343-1.944 4.793-.224.337-.588.52-.963.52M71.15 13.837c-3.665 0-6.645 2.975-6.645 6.632 0 3.647 2.98 6.616 6.644 6.616 3.656 0 6.63-2.97 6.63-6.616 0-3.657-2.974-6.632-6.63-6.632m0 15.544c-4.933 0-8.942-4-8.942-8.912 0-4.924 4.01-8.932 8.94-8.932 4.923 0 8.928 4.008 8.928 8.932 0 4.913-4.005 8.912-8.927 8.912m2.75 4.828c-.533 0-1.013-.37-1.128-.912-.128-.623.27-1.23.894-1.36 1.452-.303 2.812-.88 4.048-1.714.53-.354 1.238-.223 1.6.306.355.524.217 1.236-.31 1.594-1.48 1.003-3.12 1.695-4.872 2.063-.075.016-.154.023-.233.023m-14.626 1.67c-.663 0-1.327-.253-1.836-.758l-.828-.824c-.947-.93-1.035-2.42-.21-3.46l2.598-3.267c-.64-1.08-1.133-2.254-1.462-3.51l-4.114-.46c-1.32-.15-2.313-1.263-2.313-2.584v-1.158c0-1.325.992-2.437 2.312-2.585l4.117-.462c.325-1.226.82-2.394 1.478-3.486l-2.612-3.26c-.83-1.04-.746-2.53.197-3.467l.835-.833c.936-.942 2.424-1.027 3.47-.19l3.328 2.656c1.048-.6 2.19-1.056 3.414-1.36l.48-4.282c.147-1.315 1.26-2.31 2.588-2.31h1.16c1.33 0 2.442.995 2.586 2.317l.49 4.35c1.383.373 2.727.983 3.995 1.82.528.35.673 1.062.324 1.59-.348.532-1.06.676-1.593.325-1.267-.836-2.615-1.4-4.004-1.676-.493-.095-.865-.498-.917-.997l-.58-5.16c-.016-.154-.147-.272-.302-.272h-1.16c-.154 0-.282.118-.302.273L69.84 7.94c-.055.503-.433.907-.925 1-1.528.29-2.918.845-4.127 1.648-.42.28-.97.25-1.357-.06l-3.96-3.164c-.123-.102-.298-.088-.403.02l-.84.84c-.11.108-.12.285-.024.406l3.128 3.907c.32.393.34.95.05 1.367-.877 1.27-1.478 2.677-1.78 4.182-.1.492-.503.863-1 .916l-4.92.55c-.156.02-.274.152-.274.306v1.158c0 .154.118.285.273.3l4.92.552c.497.056.9.427 1 .915.312 1.558.906 2.972 1.757 4.205.29.417.27.97-.046 1.368l-3.107 3.903c-.095.12-.085.298.023.406l.835.827c.112.105.29.114.402.023l3.923-3.13c.387-.308.933-.334 1.35-.062 1.262.827 2.668 1.39 4.176 1.676.626.115 1.036.715.918 1.338-.115.624-.733 1.044-1.34.916-1.532-.286-2.974-.814-4.298-1.572l-3.29 2.624c-.476.384-1.05.57-1.626.57" />
      <path
        d="M67.55 33.257l.576 5.05c.147 1.318 1.265 2.315 2.59 2.315h1.163c1.326 0 2.445-.996 2.593-2.316l.574-5.12c.072-.633-.385-1.205-1.018-1.276-.635-.07-1.207.385-1.278 1.02l-.575 5.12c-.017.148-.145.262-.298.262h-1.164c-.15 0-.278-.114-.295-.263l-.574-5.054c-.072-.634-.644-1.09-1.278-1.017-.634.07-1.09.643-1.017 1.277zM82.91 14.177l3.29-4.116c.828-1.032.748-2.52-.184-3.46l-.83-.836c-.937-.942-2.43-1.03-3.473-.207l-4.115 3.26c-.5.397-.584 1.124-.188 1.624.396.5 1.122.585 1.622.19l4.114-3.262c.12-.094.295-.084.403.025l.826.832c.106.107.115.274.02.392l-3.29 4.118c-.398.498-.317 1.225.18 1.623.5.4 1.226.317 1.624-.18zM83.656 18.965l5.283.597c.154.017.27.144.27.295v1.158c0 .15-.116.278-.27.295l-5.262.598c-.633.072-1.09.644-1.017 1.278.073.633.645 1.09 1.28 1.017l5.26-.597c1.318-.147 2.32-1.26 2.32-2.59v-1.16c0-1.328-1.002-2.443-2.323-2.59l-5.282-.597c-.633-.072-1.205.384-1.277 1.018-.072.633.384 1.205 1.018 1.277zM81.127 28.158l3.27 4.11c.093.12.083.288-.025.396l-.818.816c-.108.108-.284.118-.4.024l-4.05-3.234c-.498-.4-1.225-.317-1.623.18-.397.5-.316 1.226.182 1.624l4.048 3.234c1.037.83 2.537.745 3.476-.193l.818-.816c.938-.938 1.025-2.428.2-3.468l-3.27-4.112c-.397-.5-1.123-.582-1.623-.185-.498.398-.58 1.124-.183 1.623z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.18 13h11.64v1.68H.18V13zm11.64-7.5L6 11.32.18 5.5H3.5v-5h5v5h3.32z"
      fill="#7F7F7F"
      fillRule="evenodd"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg
    width="11px"
    height="20px"
    viewBox="0 0 11 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="new-footer"
        transform="translate(-1069.000000, -1761.000000)"
        fill="#AA998D"
      >
        <g id="Group-3" transform="translate(957.000000, 1757.000000)">
          <path
            d="M118.981735,11 L122.231735,11 L121.825485,14.25 L118.981735,14.25 L118.981735,24 L114.766891,24 L114.766891,14.25 L112.481735,14.25 L112.481735,11 L114.766891,11 L114.766891,8.81640625 C114.766891,7.39452414 115.122356,6.3196651 115.833297,5.59179688 C116.544238,4.86392865 117.729122,4.5 119.387985,4.5 L122.231735,4.5 L122.231735,7.75 L120.505172,7.75 C119.86194,7.75 119.44723,7.85156148 119.261032,8.0546875 C119.074833,8.25781352 118.981735,8.5963518 118.981735,9.0703125 L118.981735,11 Z"
            id=""
          />
        </g>
      </g>
    </g>
  </svg>
);

const HelpIcon = () => (
  <svg
    width="135"
    height="120"
    viewBox="0 0 135 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="nonzero" fill="#FFF">
      <path d="M119.397 41.985H75.924c.15-.788.23-1.592.23-2.412V13.1C76.153 5.944 70.28.122 63.06.122H13.09C5.87.122 0 5.944 0 13.1v26.473c0 7.155 5.87 12.975 13.09 12.975h7.688l-.415 9.584c-.037.865.415 1.678 1.173 2.107.36.203.76.305 1.16.305.44 0 .883-.125 1.268-.372l18.12-11.625h2.295c-.475 1.463-.734 3.022-.734 4.64V89.19c0 8.383 6.88 15.203 15.337 15.203h6.625l14.61 14.79c.446.452 1.05.695 1.667.695.26 0 .52-.043.774-.13.854-.3 1.458-1.06 1.547-1.955l1.34-13.4h33.85c8.46 0 15.34-6.82 15.34-15.203V57.188c0-8.383-6.882-15.203-15.34-15.203zm-72.56 5.936h-5.443c-.45 0-.89.13-1.268.372L25.22 57.855l.327-7.52c.027-.632-.207-1.245-.647-1.7-.44-.457-1.05-.714-1.685-.714H13.09c-4.644 0-8.422-3.744-8.422-8.347V13.1c0-4.605 3.778-8.35 8.42-8.35h49.974c4.645 0 8.424 3.745 8.424 8.35v26.473c0 .83-.12 1.636-.358 2.412H58.982c-4.94 0-9.338 2.33-12.145 5.936zm83.232 41.27c0 5.83-4.788 10.576-10.673 10.576H83.434c-1.2 0-2.204.9-2.322 2.085l-1.056 10.556-11.8-11.945c-.438-.443-1.04-.694-1.666-.694h-7.607c-5.883 0-10.67-4.744-10.67-10.576V57.188c0-5.832 4.787-10.576 10.67-10.576h60.414c5.885 0 10.673 4.744 10.673 10.576V89.19z" />
      <path d="M48.24 17.675c-.318-5.064-4.41-9.12-9.518-9.434-2.844-.174-5.55.79-7.62 2.718-2.04 1.9-3.21 4.583-3.21 7.357 0 1.278 1.045 2.314 2.335 2.314s2.334-1.037 2.334-2.315c0-1.525.618-2.94 1.74-3.985 1.12-1.044 2.588-1.566 4.132-1.47 2.718.166 4.98 2.407 5.15 5.102.126 2.035-.882 3.96-2.632 5.02-3.26 1.98-5.208 5.4-5.208 9.15 0 1.276 1.045 2.312 2.334 2.312 1.29 0 2.334-1.036 2.334-2.313 0-2.125 1.113-4.07 2.977-5.2 3.227-1.96 5.087-5.505 4.852-9.255z" />
      <ellipse cx="89.188" cy="74.192" rx="2.334" ry="2.314" />
      <ellipse cx="99.188" cy="74.192" rx="2.334" ry="2.314" />
      <ellipse cx="79.188" cy="74.192" rx="2.334" ry="2.314" />
      <ellipse cx="38.073" cy="40.708" rx="2.334" ry="2.314" />
    </g>
  </svg>
);

const LightBulbIcon = () => (
  <svg
    width="56"
    height="64"
    viewBox="0 0 56 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none">
      <path
        d="M35.366 48.933c.804-2.666 2.41-5.066 4.554-6.933 4.018-3.333 6.563-8.4 6.563-14 0-10.4-8.706-18.933-19.42-18.4-9.51.4-17.278 8.4-17.546 17.867-.133 5.866 2.41 11.066 6.563 14.533 2.277 1.867 3.884 4.267 4.688 6.933h14.598z"
        fill="#FFD15C"
      />
      <path
        d="M26.26 49.2h1.204l-5.357-19.867h.402c.667 0 1.337-.266 1.873-.8.268-.266.535-.4.937-.4.403 0 .67.134.94.4.936 1.067 2.544 1.067 3.48 0 .27-.266.537-.4.94-.4.266 0 .668.134.936.4.536.534 1.072.8 1.875.8h.404L28.67 49.2h1.205l5.49-20.8c0-.267 0-.533-.267-.667-.268-.133-.535 0-.67.134-.267.266-.535.4-.803.4-.402 0-.67-.134-1.07-.4-.537-.534-1.073-.8-1.742-.8-.67 0-1.206.266-1.742.8-.533.533-1.337.533-1.873 0-.4-.534-1.07-.8-1.74-.8-.67 0-1.34.266-1.742.8-.268.266-.67.4-1.07.4-.27 0-.67-.134-.805-.4-.135-.134-.403-.267-.67-.134-.268.134-.402.4-.268.667l5.357 20.8z"
        fill="#FFF"
      />
      <g fill="#344A5E">
        <path d="M23.848 61.2c.67 1.6 2.277 2.8 4.152 2.8s3.482-1.2 4.152-2.8h-8.304z" />
        <path d="M32.955 61.333h-9.777c-1.34 0-2.41-1.066-2.41-2.4V48.8h14.598v10.133c0 1.334-1.07 2.4-2.41 2.4z" />
      </g>
      <path
        d="M35.232 53.867H20.768c-.804 0-1.473-.667-1.473-1.467s.67-1.467 1.473-1.467h14.464c.804 0 1.473.667 1.473 1.467s-.67 1.467-1.473 1.467zm0 4.666H20.768c-.804 0-1.473-.666-1.473-1.466 0-.8.67-1.467 1.473-1.467h14.464c.804 0 1.473.667 1.473 1.467s-.67 1.466-1.473 1.466z"
        fill="#415A6B"
      />
      <path
        d="M28 0c-.67 0-1.34.533-1.34 1.333v4.534c0 .666.536 1.333 1.34 1.333s1.34-.533 1.34-1.333V1.333C29.34.533 28.67 0 28 0zM10.053 8.133c-.536-.533-1.34-.533-1.875 0-.535.534-.536 1.334 0 1.867l3.215 3.2c.535.533 1.34.533 1.875 0 .535-.533.535-1.333 0-1.867l-3.215-3.2zM5.9 26.533H1.35c-.67 0-1.34.534-1.34 1.334 0 .666.536 1.333 1.34 1.333H5.9c.67 0 1.34-.533 1.34-1.333 0-.667-.67-1.334-1.34-1.334zm5.492 16l-3.214 3.2c-.536.534-.536 1.334 0 1.867.536.533 1.34.533 1.875 0l3.214-3.2c.536-.533.536-1.333 0-1.867-.535-.533-1.34-.533-1.875 0zm33.216 0c-.536-.533-1.34-.533-1.876 0-.535.534-.535 1.334 0 1.867l3.215 3.2c.536.533 1.34.533 1.875 0 .535-.533.536-1.333 0-1.867l-3.214-3.2zm10.044-16H50.1c-.67 0-1.34.534-1.34 1.334 0 .666.535 1.333 1.34 1.333h4.552c.67 0 1.34-.533 1.34-1.333 0-.667-.536-1.334-1.34-1.334zm-8.705-18.4l-3.215 3.2c-.535.534-.535 1.334 0 1.867.536.533 1.34.533 1.875 0l3.215-3.2c.536-.533.536-1.333 0-1.867-.536-.533-1.34-.533-1.875 0z"
        fillOpacity=".4"
        fill="#FFD15C"
      />
    </g>
  </svg>
);

const LinkedinIcon = () => (
  <svg
    width="23px"
    height="23px"
    viewBox="0 0 23 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="new-footer"
        transform="translate(-1197.000000, -1759.000000)"
        fill="#AA998D"
      >
        <g id="Group-3" transform="translate(957.000000, 1757.000000)">
          <path
            d="M245.2775,9.78235031 L245.2775,24.1607157 L240.489548,24.1607157 L240.489548,9.78235031 L245.2775,9.78235031 Z M245.582188,5.34261288 C245.596696,6.72096274 244.552052,7.82364262 242.883524,7.82364262 L242.854506,7.82364262 C241.244013,7.82364262 240.213878,6.72096274 240.213878,5.34261288 C240.213878,3.93524513 241.28754,2.86158314 242.912541,2.86158314 C244.552052,2.86158314 245.567679,3.93524513 245.582188,5.34261288 Z M252.691571,11.8260103 C253.321433,10.8413812 254.457678,9.44864456 257.000728,9.44864456 C260.149169,9.44864456 262.499618,11.5089149 262.499618,15.9196344 L262.499618,24.1607157 L257.726175,24.1607157 L257.726175,16.4709744 C257.726175,14.5412846 257.029746,13.2209705 255.303181,13.2209705 C253.982867,13.2209705 253.199384,14.1060162 252.851169,14.962044 C252.735098,15.2812408 252.691571,15.7020002 252.691571,16.1372686 L252.691571,24.1607157 L247.918128,24.1607157 C247.976164,11.1316823 247.918128,9.78235031 247.918128,9.78235031 L252.691571,9.78235031 L252.691571,11.8260103 Z"
            id="linkedin---FontAwesome"
          />
        </g>
      </g>
    </g>
  </svg>
);

const MenuIcon = () => (
  <svg
    width="47"
    height="37"
    viewBox="0 0 47 37"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.565 3.55c-.19-.222-.33-.45-.424-.687C.048 2.626 0 2.35 0 2.035c0-.284.047-.552.14-.805C.236.978.377.757.566.568c.188-.19.407-.33.658-.426.25-.095.518-.142.8-.142h42.954c.282 0 .55.047.8.142.25.095.47.237.658.426.19.19.33.41.424.662.093.253.14.52.14.805 0 .315-.047.59-.14.828-.095.236-.236.465-.425.686-.188.188-.407.33-.658.424-.25.095-.518.142-.8.142H2.023c-.282 0-.55-.047-.8-.142-.25-.094-.47-.236-.658-.425zm45.87 13.483c.19.19.33.41.424.663.093.252.14.52.14.804 0 .284-.047.552-.14.804-.095.253-.236.473-.425.663-.188.19-.407.33-.658.426-.25.094-.518.142-.8.142H2.023c-.282 0-.55-.048-.8-.142-.25-.095-.47-.237-.658-.426-.19-.19-.33-.41-.424-.663-.093-.252-.14-.52-.14-.804 0-.284.047-.552.14-.804.095-.253.236-.473.425-.663.188-.19.407-.33.658-.426.25-.094.518-.142.8-.142h42.954c.282 0 .55.048.8.142.25.095.47.237.658.426zm0 16.418c.19.19.33.41.424.664.093.252.14.52.14.804 0 .316-.047.592-.14.828-.095.237-.236.465-.425.686-.188.19-.407.33-.658.426-.25.095-.518.142-.8.142H2.023c-.282 0-.55-.047-.8-.142-.25-.095-.47-.237-.658-.426-.19-.22-.33-.45-.424-.686-.093-.236-.14-.512-.14-.828 0-.284.047-.552.14-.804.095-.253.236-.473.425-.663.188-.188.407-.33.658-.424.25-.095.518-.142.8-.142h42.954c.282 0 .55.047.8.142.25.094.47.236.658.425z"
      fill="#23337E"
      fillRule="evenodd"
    />
  </svg>
);

const MinusIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 0c2.62 0 4.857.93 6.714 2.786C18.07 4.643 19 6.88 19 9.5c0 2.62-.93 4.857-2.786 6.714C14.357 18.07 12.12 19 9.5 19c-2.62 0-4.857-.93-6.714-2.786C.93 14.357 0 12.12 0 9.5c0-2.62.93-4.857 2.786-6.714C4.643.93 6.88 0 9.5 0zm0 18.224c2.405 0 4.46-.853 6.166-2.558 1.705-1.705 2.558-3.76 2.558-6.166 0-2.405-.853-4.46-2.558-6.166C13.96 1.63 11.906.776 9.5.776c-2.405 0-4.46.853-6.166 2.558C1.63 5.04.776 7.094.776 9.5c0 2.405.853 4.46 2.558 6.166 1.705 1.705 3.76 2.558 6.166 2.558zm.365-9.09h5.48v.777H3.654v-.775h6.21z"
      fill="#7F7F7F"
      fillRule="evenodd"
    />
  </svg>
);

const GPlusIcon = () => (
  <svg
    width="32px"
    height="21px"
    viewBox="0 0 32 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="new-footer"
        transform="translate(-1266.000000, -1762.000000)"
        fill="#AA998D"
      >
        <g id="Group-3" transform="translate(957.000000, 1757.000000)">
          <path
            d="M328.684742,15.6562401 C328.684742,21.2678539 324.921345,25.2455372 319.25616,25.2455372 C313.832046,25.2455372 309.439184,20.8526748 309.439184,15.4285612 C309.439184,10.0044476 313.832046,5.61158522 319.25616,5.61158522 C321.907949,5.61158522 324.117773,6.57587209 325.83206,8.18301686 L323.166879,10.7410556 C322.443663,10.0446262 321.171341,9.22766096 319.25616,9.22766096 C315.907941,9.22766096 313.175795,11.9999857 313.175795,15.4285612 C313.175795,18.8571367 315.907941,21.6294615 319.25616,21.6294615 C323.140093,21.6294615 324.599916,18.830351 324.827595,17.3973136 L319.25616,17.3973136 L319.25616,14.0223095 L328.524028,14.0223095 C328.617778,14.5178458 328.684742,15.0133821 328.684742,15.6562401 Z M340.296363,14.0223095 L340.296363,16.8348129 L337.497253,16.8348129 L337.497253,19.6339234 L334.684749,19.6339234 L334.684749,16.8348129 L331.885639,16.8348129 L331.885639,14.0223095 L334.684749,14.0223095 L334.684749,11.2231991 L337.497253,11.2231991 L337.497253,14.0223095 L340.296363,14.0223095 Z"
            id="google-plus---FontAwesome"
          />
        </g>
      </g>
    </g>
  </svg>
);

const OfficeTelephoneIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.557.37l-.01-.015c-.004-.008-.01-.012-.013-.018C18.4.152 18.186.03 17.94.03H5.498c-.406 0-.733.33-.733.734V15.69c0 .147.044.284.12.4.002.002.003.007.006.01.007.008.013.014.016.02.133.184.348.305.592.305h.912c-.154.994-1.007 1.76-2.044 1.76-1.047 0-1.907-.782-2.045-1.793h.92c.405 0 .732-.33.732-.732V.73c0-.145-.043-.282-.117-.395l-.01-.014C3.844.316 3.838.31 3.833.305 3.698.12 3.484 0 3.24 0H.732C.326 0 0 .328 0 .732V15.66c0 .148.043.284.117.398.004.004.006.01.008.013.005.006.01.01.014.017.134.185.347.305.592.305h1.092c.142 1.284 1.22 2.29 2.542 2.29 1.31 0 2.383-.99 2.54-2.258H17.94c.406 0 .732-.33.732-.732V.764c.002-.146-.042-.282-.115-.395zm-9.08 10.707c0 .173-.14.312-.312.312H7.442c-.173 0-.312-.14-.312-.313v-.73c0-.172.14-.312.312-.312h1.723c.173 0 .313.14.313.312v.73zm0-2.484c0 .173-.14.313-.312.313H7.442c-.173 0-.312-.14-.312-.313v-.73c0-.172.14-.312.312-.312h1.723c.173 0 .313.14.313.314v.73zm0-2.483c0 .17-.14.312-.312.312H7.442c-.173 0-.312-.14-.312-.312v-.73c0-.173.14-.313.312-.313h1.723c.173 0 .313.14.313.313v.73zm3.417 4.967c0 .173-.138.312-.312.312H10.86c-.175 0-.313-.14-.313-.313v-.73c0-.172.138-.312.312-.312h1.722c.174 0 .312.14.312.312v.73zm0-2.484c0 .173-.138.313-.312.313H10.86c-.175 0-.313-.14-.313-.313v-.73c0-.172.138-.312.312-.312h1.722c.174 0 .312.14.312.314v.73zm0-2.483c0 .17-.138.312-.312.312H10.86c-.175 0-.313-.14-.313-.312v-.73c0-.173.138-.313.312-.313h1.722c.174 0 .312.14.312.313v.73zm3.417 4.967c0 .173-.14.312-.313.312h-1.72c-.175 0-.315-.14-.315-.313v-.73c0-.172.14-.312.314-.312h1.72c.175 0 .315.14.315.312v.73zm0-2.484c0 .173-.14.313-.313.313h-1.72c-.175 0-.315-.14-.315-.313v-.73c0-.172.14-.312.314-.312h1.72c.175 0 .315.14.315.314v.73zm0-2.483c0 .17-.14.312-.313.312h-1.72c-.175 0-.315-.14-.315-.312v-.73c0-.173.14-.313.314-.313h1.72c.175 0 .315.14.315.313v.73z"
      fillRule="nonzero"
      fill="#23337E"
    />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.315 12.364c.913.966.913 2.028 0 3.187-.365.452-.723.79-1.073 1.015-.35.226-.64.355-.867.387-.23.032-.556.048-.982.048-1.187 0-2.603-.644-4.246-1.932-1.31-.998-2.496-2.077-3.562-3.236C3.215 10.32 2.013 8.597.978 6.665.065 4.862-.21 3.38.158 2.222.337 1.61.764 1.08 1.434.628L1.48.58C2.03.193 2.517 0 2.943 0c.578 0 1.096.29 1.552.87l.046.048c.7.966 1.187 1.722 1.46 2.27.457.998.442 1.85-.045 2.56-.365.514-.548.885-.548 1.11 0 .097.198.386.594.87l.046.048c.73.87 1.127 1.336 1.188 1.4.03 0 .06.016.09.048l.184.194c.608.644 1.05 1.094 1.324 1.352l.045.048c.274.258.457.387.548.387.152 0 .594-.242 1.324-.725.212-.16.47-.24.775-.24.548 0 1.21.24 1.987.723.776.483 1.377.95 1.803 1.4z"
      fill="#23337E"
      fillRule="evenodd"
    />
  </svg>
);

const PlusIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 0c2.62 0 4.857.93 6.714 2.786C18.07 4.643 19 6.88 19 9.5c0 2.62-.93 4.857-2.786 6.714C14.357 18.07 12.12 19 9.5 19c-2.62 0-4.857-.93-6.714-2.786C.93 14.357 0 12.12 0 9.5c0-2.62.93-4.857 2.786-6.714C4.643.93 6.88 0 9.5 0zm0 18.224c2.405 0 4.46-.853 6.166-2.558 1.705-1.705 2.558-3.76 2.558-6.166 0-2.405-.853-4.46-2.558-6.166C13.96 1.63 11.906.776 9.5.776c-2.405 0-4.46.853-6.166 2.558C1.63 5.04.776 7.094.776 9.5c0 2.405.853 4.46 2.558 6.166 1.705 1.705 3.76 2.558 6.166 2.558zm.365-14.57v5.48h5.48v.777h-5.48v5.436H9.09V9.91H3.653v-.775H9.09v-5.48h.775z"
      fill="#7F7F7F"
      fillRule="evenodd"
    />
  </svg>
);
const Quality = () => (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        x="-1.8%"
        y="-1.7%"
        width="103.7%"
        height="104.6%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      transform="translate(3.3 2.3)"
      filter="url(#a)"
      fill="none"
      fillRule="evenodd"
    >
      <circle fill="#042053" cx="27.9" cy="27.4" r="27.3" />
      <path
        d="M34.892 27.93l-1.41 1.572-2.4-2.103c-.617.354-1.256.608-1.92.762-.66.154-1.315.23-1.962.23-1.232 0-2.337-.226-3.315-.68-.978-.455-1.805-1.075-2.483-1.86-.678-.786-1.197-1.702-1.56-2.75-.36-1.046-.542-2.163-.542-3.35 0-1.17.18-2.278.543-3.325.362-1.047.88-1.964 1.56-2.75.677-.784 1.504-1.408 2.482-1.87.978-.462 2.083-.693 3.315-.693 1.232 0 2.337.23 3.315.693.978.462 1.805 1.086 2.483 1.87.678.786 1.197 1.703 1.56 2.75.36 1.047.542 2.156.542 3.326 0 .57-.046 1.144-.138 1.72-.093.58-.23 1.145-.416 1.7-.185.554-.424 1.08-.716 1.58-.293.502-.647.945-1.063 1.33l2.125 1.848zm-7.507-3.74l1.386-1.595 2.01 1.755c.524-.63.894-1.347 1.11-2.148.215-.8.323-1.617.323-2.45 0-.784-.097-1.554-.29-2.31-.192-.753-.488-1.427-.888-2.02s-.92-1.066-1.56-1.42c-.64-.355-1.397-.532-2.275-.532-.878 0-1.636.177-2.275.53-.64.356-1.16.83-1.56 1.422-.4.593-.696 1.267-.89 2.02-.19.756-.288 1.526-.288 2.31 0 .787.097 1.557.29 2.31.192.756.488 1.43.888 2.023.4.592.92 1.066 1.56 1.42.64.354 1.397.532 2.275.532.308 0 .62-.03.936-.093.315-.062.62-.162.912-.3l-1.663-1.455zm-6.457 12.814v1.414h.882v-1.414h-.882zm-3.164 3.514V47h.882v-6.482h1.428v-.742h-1.428v-.63c0-.196.005-.378.014-.546.01-.168.044-.315.105-.44.06-.127.156-.227.287-.302.13-.075.317-.112.56-.112.103 0 .205.007.308.02.103.015.215.03.336.05v-.756c-.14-.02-.266-.033-.378-.042-.112-.01-.233-.014-.364-.014-.355 0-.646.05-.875.154-.23.103-.41.247-.54.434-.13.187-.22.41-.266.672-.047.26-.07.546-.07.854v.658h-1.232v.742h1.232zm3.164-.742V47h.882v-7.224h-.882zm2.576 0V47h.882v-3.85c0-.383.065-.735.196-1.057.13-.322.315-.6.553-.833.238-.233.52-.413.847-.54.327-.125.69-.18 1.092-.16v-.882c-.653-.028-1.216.117-1.687.434-.47.317-.82.77-1.043 1.358h-.028v-1.694h-.812zm8.736 2.114h.882c-.02-.392-.098-.733-.238-1.022-.14-.29-.33-.532-.567-.728-.238-.196-.513-.34-.826-.434-.312-.093-.65-.14-1.014-.14-.317 0-.637.037-.96.112-.32.075-.613.19-.874.35-.26.16-.474.37-.637.63-.163.26-.245.574-.245.938 0 .308.05.567.154.777.103.21.245.387.427.532.183.145.395.266.638.364.243.097.51.183.798.258l1.134.252c.196.047.39.103.58.168.192.065.363.147.512.245.15.098.268.22.357.364.088.145.132.324.132.54 0 .25-.063.463-.19.636-.125.173-.286.315-.482.427-.196.112-.408.19-.637.238-.23.047-.45.07-.665.07-.588 0-1.08-.152-1.477-.455-.396-.303-.613-.754-.65-1.35h-.882c.075.886.376 1.53.903 1.93.528.402 1.217.603 2.066.603.336 0 .677-.037 1.022-.112.345-.075.656-.198.93-.37.276-.174.503-.398.68-.673.177-.274.266-.608.266-1 0-.317-.06-.593-.182-.826-.12-.233-.278-.43-.47-.588-.19-.16-.41-.287-.657-.385-.247-.097-.497-.165-.75-.202l-1.175-.266c-.15-.037-.313-.086-.49-.147-.177-.06-.34-.138-.49-.23-.15-.094-.273-.21-.37-.344-.1-.134-.148-.3-.148-.496 0-.233.05-.43.154-.588.103-.16.238-.287.406-.385.168-.097.352-.167.553-.21.2-.04.4-.062.595-.062.252 0 .49.03.714.09.224.062.422.157.595.288.172.13.31.296.412.497.103.2.16.436.168.707zm3.808-2.114v-2.17h-.882v2.17h-1.26v.742h1.26v4.942c-.01.616.103 1.038.336 1.267.233.23.644.343 1.232.343.13 0 .26-.005.392-.014.13-.01.26-.014.392-.014V46.3c-.252.028-.504.042-.756.042-.317-.02-.516-.11-.595-.273-.08-.164-.12-.39-.12-.68v-4.872h1.47v-.742h-1.47z"
        fill="#FFF"
      />
    </g>
  </svg>
);

const TestTubeIcon = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="nonzero" fill="#7F7F7F">
      <path d="M88.74 26.255L63.69 1.26C62.876.446 61.794 0 60.643 0c-1.15 0-2.233.447-3.046 1.26-.814.81-1.262 1.89-1.262 3.04 0 .985.332 1.918.943 2.68L5.326 58.825c-7.092 7.078-7.092 18.594 0 25.672 3.436 3.43 8.004 5.317 12.862 5.317 4.86 0 9.427-1.888 12.863-5.317l51.953-51.845c.76.61 1.7.942 2.69.942 1.15 0 2.232-.447 3.045-1.26 1.68-1.675 1.68-4.403 0-6.08zm-2.033 4.053c-.27.27-.632.42-1.015.42-.384 0-.744-.15-1.016-.42l-.45-.45c-.057-.09-.123-.174-.2-.252-.08-.08-.165-.145-.255-.2L68.43 14.095c-.56-.56-1.47-.56-2.03 0-.562.56-.562 1.466 0 2.025L80.95 30.647 29.02 82.47c-2.893 2.888-6.74 4.478-10.83 4.478-4.093 0-7.94-1.59-10.833-4.478-5.972-5.96-5.973-15.658 0-21.618l51.94-51.834 3.07 3.03c.564.555 1.473.55 2.03-.012.558-.563.554-1.47-.01-2.027l-3.87-3.82c-.053-.08-.115-.158-.187-.23-.075-.074-.156-.138-.242-.193l-.46-.454c-.272-.27-.42-.63-.42-1.014 0-.383.148-.743.42-1.014.27-.27.63-.42 1.015-.42.384 0 .744.15 1.016.42l25.048 24.996c.56.56.56 1.468 0 2.026z" />
      <path d="M53.206 52.253c-1.292-1.29-2.502-1.506-3.385-1.664-.752-.136-1.206-.217-1.86-.87-.655-.654-.737-1.107-.872-1.858-.158-.88-.375-2.09-1.667-3.378-1.29-1.29-2.5-1.505-3.384-1.664-.753-.135-1.207-.216-1.862-.87-.654-.653-.736-1.106-.87-1.857-.16-.882-.377-2.09-1.67-3.378-.268-.27-.633-.42-1.014-.42-.38 0-.746.15-1.016.42L24.527 47.77c-.56.56-.56 1.467 0 2.026.56.56 1.47.56 2.03 0l9.8-9.78c.046.178.08.37.118.583.16.88.376 2.088 1.668 3.378 1.292 1.29 2.502 1.505 3.385 1.663.753.136 1.207.218 1.862.87.654.654.736 1.108.87 1.86.16.88.376 2.088 1.668 3.377 1.292 1.288 2.5 1.505 3.385 1.664.215.04.406.073.585.118l-24.94 24.888c-1.805 1.802-4.21 2.794-6.77 2.794-2.56 0-4.964-.992-6.77-2.794-3.732-3.725-3.732-9.786 0-13.51L22.497 53.85c.56-.56.56-1.467 0-2.027s-1.47-.56-2.03 0L9.387 62.878c-4.853 4.843-4.853 12.722 0 17.565 2.347 2.343 5.473 3.633 8.8 3.633 3.328 0 6.454-1.29 8.8-3.633l26.143-26.09c.823-.82.443-1.697.126-2.047l-.05-.053zM64.884 30.806c-.56.56-.56 1.467 0 2.027s.56 1.468 0 2.026c-.27.27-.632.42-1.016.42-.383 0-.744-.15-1.015-.42-.56-.56-.56-1.47 0-2.027.56-.56.56-1.468 0-2.027-.56-.56-1.47-.56-2.03 0-1.68 1.676-1.68 4.403 0 6.08.813.812 1.894 1.26 3.045 1.26 1.15 0 2.233-.448 3.047-1.26 1.68-1.676 1.68-4.404 0-6.08-.56-.56-1.47-.56-2.03 0zM47.96 38.483c1.15 0 2.23-.448 3.045-1.26.814-.812 1.262-1.89 1.262-3.04 0-1.148-.448-2.228-1.262-3.04-.56-.56-1.47-.56-2.03 0-.562.56-.562 1.467 0 2.027.27.27.42.63.42 1.013 0 .383-.15.743-.42 1.013-.272.27-.633.42-1.016.42-.385 0-.746-.15-1.017-.42-.27-.27-.42-.63-.42-1.013 0-.383.15-.743.42-1.013.56-.56.56-1.467 0-2.027s-1.47-.56-2.03 0c-1.68 1.676-1.68 4.404 0 6.08.813.812 1.894 1.26 3.046 1.26z" />
    </g>
  </svg>
);

const TwitterIcon = () => (
  <svg
    width="25px"
    height="20px"
    viewBox="0 0 25 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines-Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="new-footer"
        transform="translate(-1126.000000, -1761.000000)"
        fill="#AA998D"
      >
        <g id="Group-3" transform="translate(957.000000, 1757.000000)">
          <path
            d="M193.34111,6.8359375 C192.731732,7.78385891 191.91924,8.63020461 190.90361,9.375 L190.90361,9.984375 C190.90361,13.5390803 189.625628,16.7636574 187.069625,19.6582031 C184.513623,22.5527488 181.119777,24 176.887985,24 C174.179638,24 171.674455,23.2552158 169.37236,21.765625 C169.914029,21.8333337 170.303348,21.8671875 170.540328,21.8671875 C172.808569,21.8671875 174.839799,21.1562571 176.634078,19.734375 C175.584594,19.7005207 174.636687,19.3704458 173.790328,18.7441406 C172.94397,18.1178354 172.368455,17.313807 172.063766,16.3320312 C172.470018,16.3997399 172.774702,16.4335938 172.977828,16.4335938 C173.316372,16.4335938 173.756472,16.3658861 174.298141,16.2304688 C173.180948,15.9934884 172.241504,15.4264368 171.479782,14.5292969 C170.718059,13.632157 170.337203,12.5911518 170.337203,11.40625 L170.337203,11.3554688 C171.081999,11.7617208 171.826783,11.9648438 172.571578,11.9648438 C171.115842,11.0169223 170.387985,9.6458423 170.387985,7.8515625 C170.387985,7.0052041 170.608035,6.19271223 171.048141,5.4140625 C173.654925,8.63022441 177.023381,10.3398427 181.15361,10.5429688 C181.085901,10.3059884 181.052047,9.93359629 181.052047,9.42578125 C181.052047,8.03775348 181.526001,6.86979641 182.473922,5.921875 C183.421844,4.97395359 184.589801,4.5 185.977828,4.5 C187.365856,4.5 188.55074,5.02473434 189.532516,6.07421875 C190.548146,5.90494707 191.597615,5.49870113 192.680953,4.85546875 C192.34241,6.04037051 191.614553,6.95442387 190.49736,7.59765625 C191.546844,7.49609324 192.494751,7.24218953 193.34111,6.8359375 Z"
            id="ion-social-twitter---Ionicons"
          />
        </g>
      </g>
    </g>
  </svg>
);

const YoutubeIcon = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.536 13.884v2.355c0 .5-.145.747-.436.747-.167 0-.334-.078-.502-.246v-3.358c.168-.168.335-.246.502-.246.29 0 .436.257.436.748zm3.772.01v.514h-1.004v-.513c0-.502.167-.76.502-.76.335 0 .502.258.502.76zm-10.78-2.432H4.72v-1.05H1.24v1.05h1.17v6.35h1.117v-6.35zm3.213 6.35h.994V12.3H6.74v4.218c-.222.312-.434.47-.635.47-.134 0-.212-.08-.234-.236-.01-.033-.01-.156-.01-.39V12.3h-.994v4.363c0 .39.034.647.09.815.09.28.323.413.647.413.357 0 .736-.223 1.138-.68v.603zm4.79-1.65v-2.2c0-.513-.023-.882-.1-1.105-.124-.413-.403-.625-.794-.625-.368 0-.714.2-1.038.603v-2.422h-.993v7.4h.993v-.536c.335.413.68.614 1.038.614.39 0 .67-.21.793-.613.077-.235.1-.603.1-1.116zm3.77-.113v-.146h-1.014c0 .402-.01.625-.023.68-.055.27-.2.403-.446.403-.346 0-.513-.257-.513-.77v-.97H15.3v-1.15c0-.593-.1-1.017-.3-1.296-.29-.378-.68-.568-1.183-.568-.513 0-.904.19-1.194.57-.212.278-.313.702-.313 1.294v1.93c0 .592.112 1.028.324 1.295.29.38.68.57 1.205.57.524 0 .937-.2 1.205-.59.122-.18.212-.38.234-.604.02-.1.02-.323.02-.647zM8.517 5.86V3.515c0-.514-.145-.77-.48-.77-.324 0-.48.256-.48.77V5.86c0 .513.156.78.48.78.335 0 .48-.267.48-.78zm8.024 8.38c0 1.285-.01 2.657-.29 3.907-.212.882-.926 1.53-1.786 1.62C12.41 20 10.334 20 8.27 20c-2.065 0-4.14 0-6.194-.234-.86-.09-1.585-.737-1.786-1.62C0 16.897 0 15.527 0 14.242c0-1.294.01-2.655.29-3.905.212-.882.927-1.53 1.797-1.63 2.042-.223 4.118-.223 6.183-.223 2.065 0 4.14 0 6.194.223.86.1 1.585.748 1.786 1.63.29 1.25.29 2.61.29 3.906zM5.402 0l-.76 2.935L3.85 0H2.667c.235.692.48 1.395.726 2.087.357 1.038.58 1.82.68 2.366v3.025H5.19V4.453L6.54 0H5.402zm4.13 3.717V5.67c0 .59-.1 1.038-.313 1.317-.28.38-.67.57-1.184.57-.503 0-.893-.19-1.172-.57-.212-.29-.313-.726-.313-1.317V3.717c0-.592.102-1.027.314-1.306.28-.38.67-.568 1.172-.568.513 0 .904.19 1.183.57.21.278.31.713.31 1.305zm3.738-1.81h-1.016v4.254c-.223.324-.435.48-.636.48-.134 0-.212-.09-.234-.245-.01-.022-.01-.156-.01-.39V1.907h-1.017v4.398c0 .402.034.67.09.837.1.28.334.413.658.413.368 0 .748-.223 1.15-.692v.614h1.015v-5.57z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const Play = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.163 27.54L26.583 19l-11.42-8.587V27.54zM19 0c3.47 0 6.683.868 9.637 2.603 2.862 1.645 5.115 3.898 6.76 6.76C37.132 12.317 38 15.53 38 19c0 3.47-.868 6.683-2.603 9.637-1.645 2.862-3.898 5.115-6.76 6.76C25.683 37.132 22.47 38 19 38c-3.47 0-6.683-.868-9.637-2.603-2.862-1.675-5.115-3.943-6.76-6.806C.868 25.64 0 22.44 0 19c0-3.44.868-6.638 2.603-9.59C4.278 6.545 6.546 4.277 9.41 2.602 12.36.868 15.56 0 19 0z"
      fill="#F2F1F0"
      fillRule="evenodd"
    />
  </svg>
);

const Calendar = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.875 8.45v3.754h-3.75V8.45h3.75zM10.625.312H12.5v1.25h.938c.416 0 .78.158 1.093.47.314.314.47.68.47 1.096v10.638c0 .418-.156.783-.47 1.095-.31.313-.676.47-1.092.47H1.562c-.416 0-.78-.157-1.093-.47-.314-.312-.47-.677-.47-1.095V3.128c0-.416.156-.78.47-1.094.31-.313.676-.47 1.093-.47H2.5V.314h1.875v1.25h6.25V.314zm2.813 13.455V5.476H1.562v8.292h11.876z"
      fill="#23337E"
      fillRule="evenodd"
    />
  </svg>
);
const SuccessCheck = () => (
  <svg
    className="checkmark"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
  >
    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
    <path
      className="checkmark__check"
      fill="none"
      d="M14.1 27.2l7.1 7.2 16.7-16.8"
    />
  </svg>
);
const Checked = ({
  CheckedColor = '#23337E',
  isChecked,
  CheckedOnClick
}: SeparabilityProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    onClick={CheckedOnClick}
  >
    <defs>
      <rect id="a" width="26" height="26" rx="4" />
    </defs>

    <rect
      x=".5"
      y="42.5"
      width="25"
      height="25"
      rx="4"
      transform="translate(0 -42)"
      stroke={CheckedColor}
      fill="none"
      fillRule="evenodd"
    />
    {isChecked && (
      <g fill="none" fillRule="evenodd">
        <g>
          <use fill={CheckedColor} xlinkHref="#a" />
          <rect
            stroke={CheckedColor}
            x=".5"
            y=".5"
            width="25"
            height="25"
            rx="4"
          />
        </g>
        <path
          d="M19.484 6.134c-.494-.277-1.124-.11-1.41.355l-6.597 10.94-3.692-3.26c-.39-.394-1.043-.413-1.46-.038-.414.365-.436.997-.046 1.392l4.716 4.167c.39.396 1.042.416 1.458.04.126-.108 7.408-12.253 7.408-12.253.284-.464.115-1.077-.378-1.343z"
          fill="#FFF"
        />
      </g>
    )}
  </svg>
);

const HazardousMaterial = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 661.59 573.71"
    width="21"
    height="18"
  >
    <path d="M661.59,287.06c-2.41,4.07-4.86,8.11-7.22,12.2q-17.88,31.07-35.73,62.14Q604.06,386.71,589.43,412q-21,36.48-42.09,72.95Q535,506.27,522.67,527.58q-13,22.54-26,45.13a2,2,0,0,1-2,1H312.13q-72.84,0-145.69,0a2.18,2.18,0,0,1-2.18-1.27Q152.07,551.19,139.78,530q-14.48-25.1-28.92-50.2Q99.1,459.43,87.31,439q-9.65-16.73-19.25-33.47-11.65-20.2-23.34-40.39Q34,346.6,23.27,328q-4.83-8.37-9.64-16.75Q6.85,299.39.15,287.49a2.28,2.28,0,0,1,.14-1.9c4.54-8,9.14-15.88,13.73-23.82q11.51-19.94,23-39.86,8.67-15,17.35-29.95Q64.8,173.9,75.19,155.82q14.43-25,28.88-50,15.89-27.48,31.79-55C145.05,34.88,154.27,19,163.36,3a5.1,5.1,0,0,1,5.22-3c21.73.14,43.46.05,65.19.06L465.33.11c9.7,0,19.4.06,29.1,0a2.65,2.65,0,0,1,2.67,1.53q10.27,18,20.63,35.88,11.67,20.2,23.35,40.39,13.47,23.34,26.92,46.7,14.43,25,28.87,50.05,12.81,22.22,25.6,44.45,18.1,31.37,36.26,62.72l2.86,4.92ZM329.85,535v.07h39q51.53,0,103.05,0a2.6,2.6,0,0,0,2.67-1.5c2.28-4.15,4.7-8.23,7.07-12.33q13.72-23.74,27.45-47.48t27.23-47.26q12.87-22.27,25.76-44.52,8.65-15,17.3-30,12.54-21.82,25-43.66c3.9-6.79,7.79-13.57,11.74-20.33a2.12,2.12,0,0,0,0-2.5c-4.13-7.08-8.17-14.2-12.27-21.29q-19.11-33.12-38.25-66.23-14.32-24.82-28.61-49.67-19.15-33.18-38.34-66.35Q486.6,61,474.54,40a2.29,2.29,0,0,0-2.31-1.3c-13.06,0-26.12,0-39.17,0q-121.93,0-243.85-.06a2.54,2.54,0,0,0-2.54,1.49q-12,21-24.15,41.92-15.79,27.36-31.62,54.7Q113,167.67,95.18,198.57,82.63,220.32,70.1,242.08T45,285.42A2.18,2.18,0,0,0,45,288c4.46,7.77,8.83,15.59,13.29,23.35,7,12.19,14.1,24.34,21.12,36.52q17.25,29.91,34.47,59.85,10,17.34,20,34.65,11.58,20.07,23.12,40.18c9.6,16.64,19.26,33.24,28.77,49.93a4.48,4.48,0,0,0,4.62,2.66c27.1-.09,54.2-.06,81.31-.05Z" />
    <path d="M294.82,143.6l-26.33,27.66c-2.6-2.12-5.07-4.29-7.7-6.24A53.9,53.9,0,0,0,238,155.16c-13.09-2.37-25.71-.67-37.46,5.7-14.63,7.93-24.37,20-28.43,36.18-4.22,16.82-1.49,32.56,8.42,47a56.28,56.28,0,0,0,47,24.35c10.95-.14,21.89,0,32.84,0,.3,0,.59,0,1,.07v38.45c-.53,0-1.07.09-1.61.09-11.42,0-22.85,0-34.28,0a41.81,41.81,0,0,0-13.08,1.95c-13.82,4.48-25.5,12.1-33.18,24.71-11.29,18.51-12.14,37.73-2.45,57.13,6.3,12.63,16.38,21.52,29.47,26.68,14.78,5.82,29.62,5.48,44.24-.83a54.26,54.26,0,0,0,16-10.62c.59-.57,1.2-1.11,1.92-1.78l26.31,27.94c-29.88,30.94-84.58,40-126.46,7.51a96.26,96.26,0,0,1,1.25-151.87c-25.51-20.56-38.65-47-37.76-79.58.71-26.32,10.92-49,30.37-66.84C205,102,264,111.58,294.82,143.6Z" />
    <path d="M482.94,267.83q-.53,19.07-1.05,38.25a67.05,67.05,0,0,0-7.22.37c-9.71,1.54-17.07,6.61-21.56,15.4-5.62,11-11,22.12-16.49,33.19-1.42,2.86-2.88,5.7-4.21,8.61a2.81,2.81,0,0,0,0,2.13q10.32,21.09,20.76,42.11c3.43,6.88,9.19,11.1,16.3,13.62a30,30,0,0,0,11,1.39c.44,0,.89,0,1.44.07.36,12.85.7,25.6,1.07,38.82-4.32-.24-8.44-.22-12.49-.73a67,67,0,0,1-26.82-9.27c-9.68-5.9-17.74-13.48-23.29-23.41-3.43-6.14-6.29-12.59-9.41-18.91-.14-.27-.31-.52-.63-1.07-1,2.06-1.94,3.91-2.85,5.76-2.06,4.2-3.94,8.5-6.22,12.58a65.76,65.76,0,0,1-17.63,20.64,67.13,67.13,0,0,1-32,13.42c-4,.54-8.11.52-12.16.74a15.07,15.07,0,0,1-1.73-.11c.35-12.87.69-25.67,1-38.26,3.34-.31,6.59-.24,9.66-1a28.19,28.19,0,0,0,19.84-15.76c6.61-13.55,13.33-27.05,20-40.6a2.77,2.77,0,0,0,.07-2.13q-10.56-21.57-21.22-43.1c-2.1-4.24-5.59-7.2-9.46-9.75a25.23,25.23,0,0,0-11.32-4.46c-2.23-.23-4.49-.24-6.94-.36-.74-12.72-1.49-25.51-2.26-38.73,4.27.21,8.39.18,12.46.64a66.86,66.86,0,0,1,29.15,10.32c8.89,5.73,16.33,13,21.5,22.23,3.3,5.92,6,12.18,9,18.29.31.65.63,1.29,1.09,2.21.36-.64.64-1.08.87-1.56,2.66-5.51,5.11-11.14,8-16.53a64.58,64.58,0,0,1,21.56-23.76,68.47,68.47,0,0,1,41.08-11.61l.77,0C482.64,267.6,482.68,267.65,482.94,267.83Z" />
  </svg>
);

const PilotTest = () => (
  <svg
    width="68px"
    height="68px"
    viewBox="0 0 68 68"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Pilot-test" fill="#8D7F70" fillRule="nonzero">
        <g id="Group-8">
          <path
            d="M17.35,9.86 L17.35,17.17 C17.35,17.17 18,17.41 25.19,19.58 C24.8255705,17.5038091 23.9298444,15.5573274 22.59,13.93 C21.1836957,12.1842102 19.3894723,10.7906055 17.35,9.86 Z"
            id="Shape"
          />
          <path
            d="M57.82,9.64 C49.36,7.14 41.47,4.84 28,0.92 L21.22,3 C22.0208989,3.44142217 22.795532,3.92890676 23.54,4.46 L28,3.07 C41,6.84 48.87,9.15 57.22,11.62 C62.84,13.28 65.57,18.13 65.57,26.45 L65.57,34.08 L57.8,36.71 C57.8,35.17 57.8,32.71 57.8,29.29 C57.8,22.47 57.04,16.04 46.22,12.79 L26.54,6.89 C27.395989,7.70325784 28.1977102,8.57178905 28.94,9.49 C31.9510626,13.0714046 33.7257058,17.5290558 34,22.2 C48.09,26.45 46.23,27.94 46.23,35.41 L57.84,38.89 L67.67,35.57 L67.67,26.45 C67.65,21.57 66.85,12.31 57.82,9.64 Z"
            id="Shape"
          />
          <path
            d="M41.58,45.37 L29.65,30.51 C34.03,25.86 33.43,17.41 27.81,10.4 C23.37,4.87 17,1.7 11.39,1.7 C9.09700701,1.65402549 6.83965003,2.27219402 4.89,3.48 C-1.43,7.54 -1.43,17.26 4.89,25.14 C9.32,30.66 15.69,33.83 21.29,33.83 C22.7460221,33.8408401 24.1932965,33.6041364 25.57,33.13 L37.5,48 C38.2043095,48.9135293 39.268705,49.4785337 40.42,49.55 C40.8295306,49.5581894 41.2325907,49.4470004 41.58,49.23 C42.7,48.51 42.7,46.78 41.58,45.37 Z M23.72,27 C22.4669388,27.7789075 21.0151465,28.178324 19.54,28.15 C15.93,28.15 11.82,26.15 8.97,22.54 C4.9,17.44 4.9,11.19 9,8.57 C10.2530612,7.79109252 11.7048535,7.39167597 13.18,7.42 C16.79,7.42 20.9,9.47 23.75,13.03 C27.79,18.1 27.79,24.35 23.72,27 Z"
            id="Shape"
          />
          <path
            d="M61.76,53.79 C59.89,51.38 57.95,48.88 57.95,44.79 C57.95,44.2763752 57.5336248,43.8600001 57.02,43.8600001 C56.5063752,43.8600001 56.09,44.2763752 56.09,44.79 C56.09,48.79 54.33,51.26 52.63,53.62 C51.12,55.71 49.7,57.69 49.7,60.49 C49.6476835,62.4461895 50.3983075,64.338551 51.7773064,65.7269951 C53.1563052,67.1154391 55.0434989,67.8789626 57,67.84 C60.87,67.84 64.88,65.1 64.88,60.52 C64.9,57.83 63.38,55.87 61.76,53.79 Z M55.91,64.74 C55.8631148,64.9747181 55.6593078,65.1452504 55.42,65.15 L55.31,65.15 C53.5682627,64.7827114 52.3187863,63.2500204 52.31,61.47 C52.3097932,61.1904445 52.5306513,60.9607521 52.81,60.95 C52.9443323,60.9473128 53.0740935,60.9988025 53.1700357,61.0928636 C53.265978,61.1869246 53.3200269,61.3156408 53.32,61.45 C53.3251098,62.7380207 54.2082603,63.8564029 55.46,64.16 C55.5988458,64.1720556 55.7263592,64.2415145 55.8117915,64.3516273 C55.8972238,64.46174 55.9328213,64.602513 55.91,64.74 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

const LabTest = () => (
  <svg
    width="45px"
    height="71px"
    viewBox="0 0 45 71"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Pilot-test"
        transform="translate(0.000000, -42.000000)"
        fill="#8D7F70"
        fillRule="nonzero"
      >
        <g id="Group-9" transform="translate(0.000000, 42.000000)">
          <g id="Lab-test">
            <path
              d="M44,61.16 C42.55,57.37 36.43,39 34.58,33.42 C34.0635695,31.8548599 33.7969673,30.2181248 33.79,28.57 L33.73,11.2 C33.73,10.49 33.28,9.52 31.25,8.92 C28.0035334,8.1342577 24.6164666,8.1342577 21.37,8.92 C19.69,9.41 19.08,10.16 18.89,10.77 C18.8548203,10.8454213 18.8344514,10.9268966 18.83,11.01 C18.8243427,11.0531487 18.8243427,11.0968513 18.83,11.14 L18.83,28.51 C18.8010916,30.1300357 18.5210971,31.7357871 18,33.27 C15.6,40.74 9.86,58.52 8.48,62.27 C7.74,64 8.26,65.7 10,67.05 C13,69.39 20.12,70.75 27.11,70.75 C33.31,70.75 39.4,69.68 42.42,67.31 C44.4171829,65.9482401 45.0934882,63.315786 44,61.16 Z M12.47,59 L13.81,54.82 C13.81,54.82 11.56,62.54 13.86,64.67 C14.8197722,65.6716401 15.9423272,66.5034128 17.18,67.13 C12.67,66.11 10.24,64.74 12.47,59 Z M21.93,10.84 C24.8114432,10.1689239 27.8085568,10.1689239 30.69,10.84 C31.0204213,10.919687 31.334898,11.0549458 31.62,11.24 C31.3179022,11.4582597 30.9792521,11.6208117 30.62,11.72 C27.752872,12.4802313 24.737128,12.4802313 21.87,11.72 C21.5126609,11.6406137 21.1734344,11.4947463 20.87,11.29 C21.1921969,11.0708684 21.5512794,10.9116525 21.93,10.82 L21.93,10.84 Z M19.93,33.9 C20.4884447,32.164786 20.7718742,30.3528616 20.77,28.53 L20.77,13.44 L21.27,13.62 C22.8781311,14.0657949 24.541358,14.2812737 26.21,14.26 C27.9006337,14.2852372 29.5856536,14.0594445 31.21,13.59 C31.3800892,13.5360684 31.5470183,13.4726354 31.71,13.4 L31.77,28.57 C31.7777667,30.4328131 32.0815562,32.2825536 32.67,34.05 C32.79,34.44 32.95,34.89 33.12,35.4 C32.92,35.33 32.72,35.25 32.48,35.18 C28.4216422,34.2001264 24.1883578,34.2001264 20.13,35.18 C19.87,35.26 19.64,35.34 19.42,35.43 C19.62,34.88 19.79,34.36 19.94,33.88 L19.93,33.9 Z M22.17,45.39 C22.1659512,44.5195076 22.687207,43.7324757 23.4902779,43.3965435 C24.2933488,43.0606112 25.2197376,43.2420795 25.8367084,43.8561808 C26.4536793,44.470282 26.6394645,45.3958147 26.3072798,46.200443 C25.9750951,47.0050713 25.1905018,47.5299906 24.32,47.53 C23.7497826,47.527354 23.2039717,47.2982952 22.8026425,46.8932153 C22.4013133,46.4881354 22.1773417,45.9402173 22.18,45.37 L22.17,45.39 Z M26.84,54.21 C26.0502328,54.21 25.41,53.5697672 25.41,52.78 C25.41,51.9902328 26.0502328,51.35 26.84,51.35 C27.6297672,51.35 28.27,51.9902328 28.27,52.78 C28.2591354,53.558068 27.6281254,54.1846343 26.85,54.19 L26.84,54.21 Z M28.41,50.21 C27.7143249,50.21 27.0871505,49.7909355 26.8209272,49.1482155 C26.5547039,48.5054956 26.7018598,47.7656929 27.1937763,47.2737763 C27.6856929,46.7818598 28.4254956,46.6347039 29.0682155,46.9009272 C29.7109355,47.1671505 30.13,47.7943249 30.13,48.49 C30.1191051,49.4282278 29.3582756,50.1846081 28.42,50.19 L28.41,50.21 Z M31.85,38.74 C28.1665371,39.7132487 24.2934629,39.7132487 20.61,38.74 C20.0481219,38.6193497 19.5234193,38.365572 19.08,38 C19.08,37.89 19.51,37.48 20.71,37.13 C22.587059,36.6653826 24.5165774,36.4468831 26.45,36.48 C28.3003224,36.4481581 30.1466191,36.6633912 31.94,37.12 C32.4912405,37.2429091 33.0074866,37.4890661 33.45,37.84 C33.4,37.93 33,38.35 31.86,38.72 L31.85,38.74 Z"
              id="Shape"
            />
            <path
              d="M14.51,3.21 C14.51,2.52 14.06,1.58 12.1,1.01 C8.97217128,0.249996597 5.70782872,0.249996597 2.58,1.01 C0.58,1.61 0.13,2.61 0.09,3.22 C0.09,3.22 0.09,48.69 0.09,53.61 C0.0416817155,55.4651395 0.739437173,57.2621512 2.02700073,58.5985858 C3.31456428,59.9350204 5.08434785,60.6992061 6.94,60.72 L14.64,37.33 C14.56,22.8 14.51,4.18 14.51,3.21 Z M3.14,2.88 C5.90332753,2.23911649 8.77667247,2.23911649 11.54,2.88 C11.8331373,2.96222847 12.1152026,3.07975566 12.38,3.23 C12.1035455,3.42211003 11.7955494,3.56426209 11.47,3.65 C8.71760043,4.38015396 5.82239957,4.38015396 3.07,3.65 C2.76433313,3.57164355 2.47374061,3.4432422 2.21,3.27 C2.49941946,3.09553409 2.8127082,2.96415494 3.14,2.88 Z M1.87,51.65 L1.87,49.81 C2.04367951,51.8517085 2.73174837,53.8161451 3.87,55.52 C4.76482433,56.869351 6.0480162,57.9154313 7.55,58.52 C3.94,58.49 1.87,56.18 1.87,51.65 Z M4.1,26.37 C4.09595631,25.4985994 4.61829903,24.7109377 5.42260097,24.3755965 C6.22690291,24.0402553 7.15407653,24.2235637 7.77025643,24.8397436 C8.38643633,25.4559235 8.56974471,26.3830971 8.23440351,27.187399 C7.8990623,27.991701 7.11140059,28.5140437 6.24,28.51 C5.05811064,28.51 4.1,27.5518894 4.1,26.37 Z M7.1,36.19 C6.15007023,36.19 5.38,35.4199298 5.38,34.47 C5.38,33.5200702 6.15007023,32.75 7.1,32.75 C8.04992977,32.75 8.82,33.5200702 8.82,34.47 C8.82276404,34.9304978 8.63967772,35.372646 8.31217399,35.6963853 C7.98467027,36.0201246 7.54043504,36.1980873 7.08,36.19 L7.1,36.19 Z M10.29,31.6 C9.71071203,31.5999858 9.18866063,31.2504856 8.96792254,30.7149025 C8.74718445,30.1793194 8.87137323,29.5634743 9.28242641,29.1552956 C9.69347959,28.7471169 10.310181,28.6272529 10.8442019,28.851744 C11.3782228,29.0762351 11.724051,29.6007262 11.72,30.18 C11.7200852,30.5618633 11.5663674,30.9276678 11.2935417,31.1948489 C11.0207159,31.46203 10.6517781,31.6080675 10.27,31.6 L10.29,31.6 Z M11.49,20.15 C8.73760043,20.880154 5.84239957,20.880154 3.09,20.15 C2.7867917,20.0693581 2.49704409,19.9446992 2.23,19.78 C2.51541979,19.5932604 2.82961456,19.4547444 3.16,19.37 C5.92332753,18.7291165 8.79667247,18.7291165 11.56,19.37 C11.8561684,19.4432742 12.1394264,19.5612983 12.4,19.72 C12.1133512,19.90922 11.7998336,20.0541798 11.47,20.15 L11.49,20.15 Z M12.12,17.46 C8.99217128,16.6999966 5.72782872,16.6999966 2.6,17.46 C2.42546491,17.506281 2.2549191,17.5664737 2.09,17.64 L2.09,5.42 L2.52,5.58 C4.06988655,6.00814408 5.67215299,6.21684265 7.28,6.2 C8.9098391,6.2207176 10.5338699,6.00170929 12.1,5.55 C12.2462918,5.50112282 12.3898346,5.44437336 12.53,5.38 C12.53,7.91 12.53,12.38 12.53,17.61 L12.12,17.46 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const SYC = () => (
  <svg
    width="56px"
    height="71px"
    viewBox="0 0 56 71"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-10" fillRule="nonzero">
        <g id="Screen-your-case">
          <path
            d="M28.27,13.21 C27.5098683,12.6702534 26.6649043,12.2612909 25.77,12"
            id="Shape"
            fill="#847770"
          />
          <path
            d="M54.33,8.5 L27.38,0.43 C27.0042784,0.310311236 26.5938029,0.38121155 26.28,0.62 C25.9627041,0.855010237 25.7739229,1.22516955 25.77,1.62 L25.77,4.77 L22.38,3.77 C21.9991524,3.65809927 21.5878402,3.73220957 21.27,3.97 C20.9552427,4.20606798 20.77,4.57655337 20.77,4.97 L20.77,8.53 L17.37,7.53 C17.1311772,7.45181156 16.8691444,7.49673147 16.67,7.65 C16.4635182,7.79788464 16.3407278,8.03602346 16.34,8.29 L16.34,20.87 C21.8445958,22.2423001 26.7353132,25.4089516 30.24,29.87 C36,37.08 37,45.9 32.9,51.41 L38.67,58.61 L43.86,60.16 C43.9363126,60.1704205 44.0136874,60.1704205 44.09,60.16 C44.3029935,60.1627136 44.5080571,60.0792998 44.6586785,59.9286785 C44.8092998,59.7780571 44.8927136,59.5729935 44.89,59.36 L44.89,56.17 L48.61,57.29 C48.7239462,57.3220521 48.841637,57.338865 48.96,57.34 C49.6503559,57.34 50.21,56.7803559 50.21,56.09 L50.21,52.94 L53.61,53.94 C53.7354247,53.9829231 53.8674736,54.0032383 54,54 C54.2661358,54.0021666 54.5257948,53.9179529 54.74,53.76 C55.0572959,53.5249898 55.2460771,53.1548304 55.25,52.76 L55.25,9.7 C55.2474604,9.13883699 54.8712616,8.6481428 54.33,8.5 Z M47.71,54.41 L44.89,53.56 L44.89,16.33 C44.8884154,15.976439 44.6576892,15.6647563 44.32,15.56 L23.32,9.26 L23.32,6.63 L47.71,14 L47.71,54.41 Z M52.71,51.08 L50.2,50.33 L50.2,13 C50.2035491,12.4487017 49.8398319,11.9623831 49.31,11.81 L28.31,5.5 L28.31,3.3 L52.76,10.63 L52.71,51.08 Z"
            id="Shape"
            fill="#8D7F70"
          />
          <path
            d="M24.1,46.52 C25.3884086,45.6745476 26.2431573,44.3084107 26.44,42.78 C26.87,40.18 25.86,37.06 23.74,34.42 C21.8606263,32.0417023 19.2662523,30.3308178 16.34,29.54 L16.34,46.47 C17.6769796,47.1004584 19.1321079,47.4412379 20.61,47.47 C21.8404084,47.494923 23.0519828,47.1651248 24.1,46.52 Z"
            id="Shape"
            fill="#8D7F70"
          />
          <path
            d="M36.15,57.85 L31,51.39 C35.46,46.64 34.84,38 29.08,30.8 C25.8543249,26.6950171 21.3838345,23.7474411 16.34,22.4 C15.0088903,22.0663522 13.6422783,21.895106 12.27,21.89 C9.91999936,21.8451657 7.60714718,22.4806791 5.61,23.72 C-0.86,27.88 -0.86,37.83 5.61,45.89 C10.15,51.55 16.68,54.8 22.4,54.8 C23.3029712,54.800661 24.2038705,54.7135853 25.09,54.54 C25.6673255,54.4291906 26.2355718,54.2754299 26.79,54.08 L27.79,55.35 L39,69.3 C39.7142911,70.249175 40.8135122,70.8317622 42,70.89 C42.4208511,70.9023745 42.8356278,70.7873524 43.19,70.56 C44.35,69.82 44.35,68.05 43.19,66.56 L36.15,57.85 Z M9.79,43.21 C5.62,38.01 5.62,31.61 9.79,28.93 C11.0760404,28.1306316 12.5660526,27.7207915 14.08,27.75 C14.8401619,27.7512796 15.5979372,27.8351043 16.34,28 C19.7310949,28.811627 22.7479289,30.746489 24.9,33.49 C29.07,38.68 29.07,45.09 24.9,47.77 C23.6193551,48.5869439 22.1289619,49.0142594 20.61,49 C19.1456812,48.9803266 17.6977683,48.6887095 16.34,48.14 C13.7641924,47.095822 11.5061798,45.3962798 9.79,43.21 Z"
            id="Shape"
            fill="#8D7F70"
          />
        </g>
      </g>
    </g>
  </svg>
);

const SolidsIcon = () => (
  <svg
    width="67px"
    height="40px"
    viewBox="0 0 67 61"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-12"
        transform="translate(-1.000000, 0.000000)"
        fill="#8D7F70"
        fillRule="nonzero"
      >
        <g id="Solid-properties">
          <path
            d="M67.34,37.89 L62.43,24.72 L65.2,23.89 C65.593682,23.7573581 65.8643564,23.3951321 65.88,22.98 L65.88,8.22 C65.8643564,7.80486794 65.593682,7.4426419 65.2,7.31 L52.89,3.62 C52.7102704,3.5685923 52.5197296,3.5685923 52.34,3.62 L43.56,6.26 L43.07,3.31 C42.9944206,2.8775163 42.6455906,2.54491099 42.21,2.49 L29.63,0.89 C29.4352841,0.863336279 29.2370279,0.89463988 29.06,0.98 L17.68,6.56 C17.2865535,6.75620815 17.0674107,7.18637736 17.14,7.62 L17.59,10.37 L5.91,10.61 C5.44513119,10.5940765 5.03066414,10.9007821 4.91,11.35 L1,25.6 C0.873619359,26.0304787 1.04940973,26.4924394 1.43,26.73 L11.43,33.11 L5.7,36.74 C5.32807361,36.9751053 5.15352167,37.4256929 5.27,37.85 L9.2,51.85 C9.32451058,52.2952375 9.73799617,52.597082 10.2,52.58 L22.87,52.8 C23.0572252,52.8006008 23.2408587,52.748629 23.4,52.65 L25.34,51.42 L28.92,56.23 C29.032939,56.3789639 29.1853717,56.4932884 29.36,56.56 L41.27,60.9 C41.3761266,60.9151797 41.4838734,60.9151797 41.59,60.9 C41.8870377,60.9033392 42.1670078,60.7614876 42.34,60.52 L51,48.92 C51.2286765,48.5816843 51.2286765,48.1383157 51,47.8 L50.61,47.28 L56.35,46.9 C56.5457165,46.8877227 56.7335038,46.8181719 56.89,46.7 L67,39 C67.3384832,38.7403902 67.4750175,38.294646 67.34,37.89 Z M64,22.27 L53.65,25.37 L53.65,13.09 L64,10 L64,22.27 Z M57.62,26.17 L50.88,31.28 L46.27,31.59 L46.27,28.59 L48.91,26.59 L52.38,27.59 C52.4727066,27.6052958 52.5672934,27.6052958 52.66,27.59 C52.7494112,27.6045589 52.8405888,27.6045589 52.93,27.59 L57.62,26.17 Z M52.62,5.53 L62.19,8.4 L52.62,11.27 L43,8.4 L52.62,5.53 Z M51.62,13.09 L51.62,25.37 L46,23.7 L41.24,16.56 L41.24,10 L51.62,13.09 Z M31.62,40.33 L25.62,31.33 L37.81,27.6 L43.81,36.65 L31.62,40.33 Z M47.48,46.15 L39,43.23 L37,40.65 L42.13,39.08 L47.48,46.15 Z M25,29.45 L24.94,18.57 L36.87,14.91 L36.93,25.8 L25,29.45 Z M38.84,25.75 L38.78,16.23 L44.32,24.54 L44.37,34.05 L38.84,25.75 Z M41.65,6.83 L40,7.31 C39.5949479,7.42657258 39.317011,7.79851755 39.32,8.22 L39.32,13.7 L38.85,13 C38.6068044,12.663488 38.1809685,12.5122565 37.78,12.62 L32.53,14.23 L31.77,9.63 L41.32,5 L41.65,6.83 Z M29.65,2.91 L38.65,4.05 L30.54,8.05 L21.54,6.91 L29.65,2.91 Z M29.84,10 L30.64,14.86 L27.54,15.81 L19.69,10.81 L19.33,8.65 L29.84,10 Z M18.43,12.38 L25,16.55 L23.69,16.95 C23.3906301,17.0517383 23.1570115,17.2890651 23.06,17.59 L16.93,17.72 L8.85,12.58 L18.43,12.38 Z M23.43,31.51 L14,31.7 L17.35,19.7 L23,19.62 L23.07,30.74 C23.0676515,30.928904 23.1235149,31.1139514 23.23,31.27 L23.43,31.51 Z M3.12,25.43 L6.46,13.43 L15.52,19.19 L12.17,31.19 L3.12,25.43 Z M14.19,33.72 L23.8,33.52 L18.63,36.8 L9.63,36.64 L14.19,33.72 Z M10.93,50.61 L7.56,38.61 L18.19,38.8 L21.56,50.8 L10.93,50.61 Z M21.75,44.4 L20,38.28 L25.55,34.76 L27.13,37.14 L21.75,44.4 Z M23.26,45.52 L28.26,38.8 L30.39,42 C30.5725259,42.2565652 30.8652299,42.41218 31.18,42.42 C31.2727066,42.4352958 31.3672934,42.4352958 31.46,42.42 L35,41.27 L37.12,44 L29.61,54 L23.26,45.52 Z M41.26,58.91 L31.26,55.25 L38.76,45.25 L48.88,48.77 L41.26,58.91 Z M49.26,45.37 L44.1,38.49 L45.6,38 C45.993682,37.8673581 46.2643564,37.5051321 46.28,37.09 L46.28,33.56 L50.56,33.28 L54.9,45 L49.26,45.37 Z M56.82,44.29 L52.41,32.61 L60.85,26.21 L65.21,37.9 L56.82,44.29 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

const LiquidsIcon = () => (
  <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 74"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Prototype---New-Guidelines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-11" fill="#8D7F70" fillRule="nonzero">
        <g id="Liquid-properties">
          <path
            d="M15.18,13.6032395 C14.9245758,13.1420526 14.3922629,12.9086538 13.88,13.0332395 C13.88,13.0332395 11.36,13.6532395 7.88,14.6532395 C7.80202639,14.6797807 7.72801716,14.7167853 7.66,14.7632395 C7.49470132,14.81143 7.35254653,14.9180461 7.26,15.0632395 C7,15.5732395 0,27.7332395 0,32.9032395 C0,37.6532395 3,41.2432395 8.42,43.0032395 C9.59510009,43.4124625 10.8261701,43.6384398 12.07,43.6732395 C12.4049081,43.6726562 12.7392587,43.6459081 13.07,43.5932395 C18.4,43.0632395 23.88,40.1932395 23.74,35.8132395 C23.53,28.7532395 15.52,14.2132395 15.18,13.6032395 Z M7.34,38.8432395 C7.28211582,39.1271134 7.02965646,39.3290809 6.74,39.3232395 L6.62,39.3232395 C6.46,39.3232395 2.89,38.4732395 2.46,33.3232395 C2.44213672,33.1053075 2.54189571,32.8944 2.72169873,32.769964 C2.90150175,32.6455279 3.13403243,32.626468 3.33169873,32.719964 C3.52936503,32.8134599 3.66213672,33.0053075 3.68,33.2232395 C4.03,37.4832395 6.84,38.1332395 6.87,38.1332395 C7.19010236,38.2079038 7.39630622,38.5194033 7.34,38.8432395 Z M16.74,40.3532395 C16.9641185,39.5733307 17.0719461,38.7646235 17.06,37.9532395 C17.06,33.7132395 11.38,21.1532395 9.29,16.6832395 C11.15,16.1532395 12.67,15.7532395 13.56,15.5232395 C15.23,18.6532395 21.25,30.2632395 21.43,35.8532395 C21.5,37.9032395 19.29,39.4532395 16.74,40.3532395 Z"
            id="Shape"
          />
          <path
            d="M41.22,0.643648325 C40.9410128,0.140844788 40.3549956,-0.106768125 39.8,0.0436483251 C39.8,0.0436483251 37.43,0.683648325 33.95,1.70364833 C33.8457686,1.73742346 33.7477964,1.78809873 33.66,1.85364833 C33.4973811,1.90163571 33.3561731,2.00401149 33.26,2.14364833 C32.97,2.66364833 26,14.8236483 26,19.9636483 C26,24.7036483 29,28.2936483 34.41,30.0536483 C35.5840152,30.4669633 36.8157311,30.6930591 38.06,30.7236483 C38.21,30.7236483 38.35,30.7236483 38.49,30.7236483 L38.64,30.7236483 L38.89,30.7236483 L38.96,30.7236483 C43.54,30.2536483 49.96,27.8436483 49.82,22.9236483 C49.55,15.8136483 41.55,1.26364833 41.22,0.643648325 Z M33.31,25.9236483 C33.2485635,26.2053345 32.9983019,26.4055439 32.71,26.4036483 L32.55,26.4036483 C32.4,26.4036483 28.83,25.5536483 28.4,20.4036483 C28.3710431,20.0699597 28.6165599,19.7753394 28.95,19.7436483 C29.2854583,19.7204528 29.5782598,19.9688904 29.61,20.3036483 C29.97,24.5736483 32.78,25.2136483 32.81,25.2236483 C33.1408275,25.2797462 33.3642299,25.5925095 33.31,25.9236483 Z M42.77,27.2536483 C42.950248,26.5276299 43.0376129,25.7816685 43.03,25.0336483 C43.03,20.8436483 37.46,8.48364833 35.32,3.90364833 C37.14,3.40364833 38.61,2.96364833 39.55,2.72364833 C41.22,5.95364833 47.13,17.4036483 47.32,22.9436483 C47.38,24.8836483 45.26,26.4036483 42.77,27.2536483 Z"
            id="Shape"
          />
          <path
            d="M38.4,34.7115147 C38.1048793,34.1786326 37.4952799,33.9022809 36.9,34.0315147 C36.76,34.0315147 33.53,34.7515147 29.08,36.0315147 L28.94,36.0915147 C28.6908896,36.1438777 28.4761235,36.3004022 28.35,36.5215147 L28.29,36.6315147 L28.23,36.7515147 C27.08,38.7515147 19,53.1715147 19,59.4515147 C19,65.5615147 22.85,70.1715147 29.83,72.4515147 C31.342883,72.9790679 32.9283339,73.2691716 34.53,73.3115147 C34.8,73.3115147 35.06,73.3115147 35.31,73.3115147 L35.52,73.3115147 L35.99,73.2315147 C44.58,71.9015147 49.6,68.2315147 49.43,63.2315147 C49.13,54.1915147 38.8,35.5015147 38.4,34.7115147 Z M28.4,67.1415147 C28.3211665,67.499461 28.0064857,67.7561743 27.64,67.7615147 L27.48,67.7615147 C27.28,67.7615147 22.68,66.6715147 22.13,60.0315147 C22.1077669,59.8222672 22.1721375,59.6130367 22.3081448,59.4524726 C22.444152,59.2919085 22.6399455,59.1940008 22.85,59.1815147 C23.0582353,59.1592391 23.2664338,59.2238773 23.4254398,59.3601682 C23.5844459,59.4964591 23.6801658,59.6923224 23.69,59.9015147 C24.15,65.3315147 27.69,66.1915147 27.81,66.2215147 C28.2212917,66.3207176 28.4814165,66.7263359 28.4,67.1415147 Z M40.46,69.2515147 C40.7766855,68.2079293 40.9318141,67.1220286 40.92,66.0315147 C40.92,60.5215147 33.44,44.0315147 30.83,38.4615147 C33.3,37.7715147 35.32,37.2715147 36.46,37.0115147 C38.54,40.8715147 46.46,56.0115147 46.66,63.3315147 C46.8,66.0315147 44,68.0315147 40.46,69.2515147 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

const SigmaGraphSmall = () => (
  <svg
    width="300px"
    height="89px"
    viewBox="0 0 300 89"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="small-bulb"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M8,88 L293,88 C234.829829,86.9913499 199.073319,81.9913499 185.730469,73 C165.716194,59.5129751 170.847645,5 150.364252,5 C129.880859,5 138.653299,53.8732587 110.757812,73 C97.7236081,81.9369962 63.4710039,86.9369962 8,88 Z"
        id="Path-7"
        fill="#1E1C77"
      />
    </g>
  </svg>
);
const SigmaGraphMedium = () => (
  <svg
    width="300px"
    height="89px"
    viewBox="0 0 300 89"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="normal-bulb"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M8,88 L293,88 C250.674881,82.3246833 222.840897,74.9913499 209.498047,66 C181.959913,47.4428702 177.872036,5 150.364252,5 C122.437484,5 117.979471,47.1935712 90.0839844,66.3203125 C77.04978,75.2573087 49.6884518,82.4838712 8,88 Z"
        id="Path-7"
        fill="#1E1C77"
      />
    </g>
  </svg>
);
const SigmaGraphBig = () => (
  <svg
    width="300px"
    height="89px"
    viewBox="0 0 300 89"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="wide-bulb"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M8,88 L293,88 C271.212642,82.5486416 253.647537,75.3272874 240.304688,66.3359375 C220.290413,52.8489126 195.498036,5 150.364252,5 C105.230469,5 84.0634552,47.2091962 56.1679688,66.3359375 C43.1337643,75.2729337 27.0777747,82.4942879 8,88 Z"
        id="Path-7"
        fill="#1E1C77"
      />
    </g>
  </svg>
);

const LoadingSpinner = () => (
  <svg width="57" height="57" viewBox="0 0 57 57" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
      <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)" strokeWidth="2">
              <circle cx="5" cy="50" r="5">
                  <animate attributeName="cy"
                       begin="0s" dur="2.2s"
                       values="50;5;50;50"
                       calcMode="linear"
                       repeatCount="indefinite" />
                  <animate attributeName="cx"
                       begin="0s" dur="2.2s"
                       values="5;27;49;5"
                       calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="27" cy="5" r="5">
                  <animate attributeName="cy"
                       begin="0s" dur="2.2s"
                       from="5" to="5"
                       values="5;50;50;5"
                       calcMode="linear"
                       repeatCount="indefinite" />
                  <animate attributeName="cx"
                       begin="0s" dur="2.2s"
                       from="27" to="27"
                       values="27;49;5;27"
                       calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="49" cy="50" r="5">
                  <animate attributeName="cy"
                       begin="0s" dur="2.2s"
                       values="50;50;5;50"
                       calcMode="linear"
                       repeatCount="indefinite" />
                  <animate attributeName="cx"
                       from="49" to="49"
                       begin="0s" dur="2.2s"
                       values="49;5;27;49"
                       calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
          </g>
      </g>
  </svg>
  );


export {
  Separation1,
  Separation2,
  Separation3,
  Separation4,
  SeparabilityDataNone,
  SeparabilityDataExists,
  SeparabilityDataOther,
  EmailIcon,
  GlobeIcon,
  ChatIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  CloseIcon,
  CogWheelsIcon,
  DownloadIcon,
  FacebookIcon,
  GPlusIcon,
  HazardousMaterial,
  HelpIcon,
  LightBulbIcon,
  LinkedinIcon,
  MenuIcon,
  MinusIcon,
  OfficeTelephoneIcon,
  PhoneIcon,
  PlusIcon,
  Quality,
  TestTubeIcon,
  TwitterIcon,
  YoutubeIcon,
  Play,
  Calendar,
  Checked,
  SuccessCheck,
  PilotTest,
  LabTest,
  SYC,
  SolidsIcon,
  LiquidsIcon,
  SigmaGraphSmall,
  SigmaGraphMedium,
  SigmaGraphBig,
  LoadingSpinner
};
